import type { UiMessages } from '../en/ui.ts'

// The Italian interface strings — the active language. Typed as `UiMessages` (derived from
// en/ui.ts): a key missing here does not compile.
export const IT_UI: UiMessages = {
  app: {
    name: 'Volée',
    bootLabel: 'Volée Football, in caricamento',
    navigationLabel: 'Navigazione principale',
    openMenu: 'Apri il menu di navigazione',
    closeMenu: 'Chiudi il menu di navigazione',
    collapseMenu: 'Restringi il menu alle icone',
    expandMenu: 'Mostra le etichette del menu',
  },
  entry: {
    headline: { lead: 'Una partita è un istante.', accent: 'La crescita è una storia.' },
    pause: 'Metti in pausa il movimento',
    resume: 'Riprendi il movimento',
    close: 'Chiudi',
  },
  navigation: {
    signIn: 'Accedi',
    signOut: 'Esci',
    signOutPartial:
      'Sei uscito da qui, ma su altri dispositivi la sessione potrebbe restare aperta.',
    settings: 'Impostazioni',
    more: 'Altro',
    closeMore: 'Chiudi',
    back: 'Indietro',
    menu: {
      staff: 'Staff',
      players: 'Giocatori',
      pitches: 'Campi',
      teams: 'Squadre',
      leagues: 'Campionati',
      requests: 'Richieste',
      subscriptions: 'Piano',
      matches: 'Partite',
    },
  },
  userMenu: {
    open: 'Il tuo account, {account}',
    devBypass: 'Bypass di sviluppo',
    onThisPhone: 'Su questo telefono',
    addAccount: 'Aggiungi un account',
    signOutOf: 'Esci da {name}',
    signOutAll: 'Esci da tutti gli account',
    switchFailed: 'Quell’account non è più collegato qui: entra di nuovo con lui.',
  },
  settings: {
    title: 'Impostazioni',
    description: 'Il tuo accesso e i tuoi recapiti.',
    devBypassHint:
      'Questa sessione non ha un’identità Cognito: non c’è niente da cui uscire e nessuna password da cambiare.',
    accessTitle: 'Il tuo accesso',
    usernameLabel: 'nome utente',
    usernameHint:
      'Entri con questo: l’ha scelto il tuo tutore, e il tutore lo cambia insieme alla password.',
    addEmailTitle: 'Una mail tua',
    addEmailDescription:
      'Se hai una mail tua, aggiungila: da lì entri con quella, e la password è tua. Il tuo tutore riceve un avviso.',
    emailLabel: 'e-mail',
    emailHint: 'È l’indirizzo con cui entri. Per cambiarlo, scrivici.',
    contactsTitle: 'I tuoi recapiti',
    contactsDescription: 'Il numero a cui la società ti trova.',
    phoneLabel: 'telefono',
    save: 'Salva',
    saved: 'Recapiti aggiornati.',
    reservedHint:
      'Nome, data di nascita e codice fiscale sono quelli con cui la società ti ha registrato: li corregge lei.',
    reservedHintWithoutClub:
      'Nome, data di nascita e codice fiscale non si cambiano da qui: per correggerli, scrivici.',
  },
  signIn: {
    title: 'Entra',
    description: 'Inserisci la tua email, o il nome utente che ha scelto il tuo tutore.',
    email: 'Email o nome utente',
    password: 'Password',
    submit: 'Entra',
    forgotPassword: 'Password dimenticata?',
    registerClub: 'Registra la tua società',
    pending: 'Accesso in corso…',
    failed: 'Accesso non riuscito. Riprova.',
    reason: {
      'session-expired': 'La tua sessione è scaduta. Entra di nuovo per continuare.',
      required: 'Per quella pagina devi aver effettuato l’accesso.',
      'account-created': 'Il tuo account è pronto: entra con la tua e-mail e la tua password.',
    },
    add: {
      title: 'Aggiungi un account',
      description:
        'Entra con un altro account: quello di adesso resta su questo telefono, e passi dall’uno all’altro dal menu.',
      back: 'Torna indietro',
    },
    onThisPhone: 'Già su questo telefono',
    continueAs: 'Continua come {name}',
  },
  signUp: {
    title: 'Creare un account',
    description: 'Registra la società che rappresenti.',
    backToSignIn: 'Torna all’accesso',
    choose: {
      title: 'Chi sei?',
      club: {
        title: 'Una società',
        body: 'Rappresenti una società e vuoi portarla su Volée.',
      },
      player: {
        title: 'Un giocatore',
        body: 'Giochi in una società che è già su Volée.',
      },
      parent: {
        title: 'Un genitore, o un tutore',
        body: 'Crei il tuo account e aggiungi i tuoi figli quando vuoi.',
      },
    },
    // Il foglio del genitore che si registra da solo: nessuna società, nessun figlio.
    parent: {
      title: 'Il tuo account',
      description: 'Bastano pochi dati. I tuoi figli li aggiungi dopo, dalla tua pagina.',
      firstName: 'il tuo nome',
      lastName: 'il tuo cognome',
      email: 'la tua e-mail',
      confirmEmail: 'conferma la tua e-mail',
      phone: 'il tuo telefono',
      required: 'Campo obbligatorio.',
      emailMismatch: 'Le e-mail non coincidono.',
      noticeTitle: 'L’informativa',
      agree:
        'Ho letto l’informativa e acconsento al trattamento dei miei dati per creare l’account.',
      agreeRequired: 'Spunta il consenso per creare l’account.',
      noticeLoading: 'Carico l’informativa…',
      noticeError: 'L’informativa non si carica: riprova tra poco.',
      submit: 'Crea l’account',
      submitting: 'Creo l’account…',
      signIn: 'Vai all’accesso',
    },
  },

  registration: {
    club: {
      title: 'La tua società',
      description:
        'Scegli la società che rappresenti, o filtra l’elenco per nome. Giocatori e genitori entrano con l’invito o il link della propria società.',
      field: 'società',
      placeholder: 'Filtra per nome',
      searching: 'Sto caricando le società…',
      empty: 'Nessuna società con questo nome.',
      failed: 'Ricerca non riuscita.',
      retry: 'Riprova',
      change: 'cambia',
      missingEyebrow: 'NON LA TROVI?',
      missingBody: 'Se la tua società non è in elenco, scrivici: la aggiungiamo noi.',
      contact: 'Contatta Volée',
      submit: 'Continua',
    },
    contact: {
      title: 'Contatta Volée',
      description: 'Dicci qual è la tua società e ti ricontattiamo per aggiungerla.',
      clubName: 'nome della società',
      email: 'e-mail',
      phone: 'telefono',
      submit: 'Invia la richiesta',
      sent: 'Richiesta inviata. Volée risponde indicativamente entro 48 ore.',
      back: 'Torna alla ricerca',
    },
    details: {
      title: 'I tuoi dati',
      description: 'Chi sei. Servono per intestare la richiesta e per ricontattarti.',
      firstName: 'nome',
      lastName: 'cognome',
      email: 'e-mail',
      phone: 'telefono',
      required: 'Campo obbligatorio.',
      submit: 'Continua',
    },
    credentials: {
      title: 'Credenziali',
      description: 'Scegli come entrerai in Volée.',
      submit: 'Continua',
      takenTitle: 'Questa e-mail è già registrata',
      takenBody:
        'Esiste già un accesso con questo indirizzo. Entra con quello, o torna indietro e usane un altro.',
    },
    document: {
      title: 'Il documento',
      description:
        'Carica un documento che attesti il tuo ruolo nella società. Lo legge un operatore Volée nel backoffice.',
      empty: 'Nessun documento caricato.',
      choose: 'Scegli un file',
      uploaded: 'caricato',
      replace: 'Sostituisci',
      remove: 'Rimuovi',
      failedTitle: 'Caricamento non riuscito',
      failedBody: 'Il file non è arrivato. Riprova.',
      retry: 'Riprova',
      submit: 'Continua',
    },
    consents: {
      title: 'Privacy e consensi',
      description: 'Cosa fa Volée dei dati che hai inserito.',
      noticeEyebrow: 'L’INFORMATIVA',
      noticeBody:
        'Volée Football S.r.l. tratta i dati di questa richiesta per valutarla e, in caso di approvazione, per darti accesso alla piattaforma come dirigente della tua società. Il documento che carichi lo legge un operatore Volée e viene conservato come prova della verifica. Puoi chiedere in ogni momento di vedere, correggere o cancellare i tuoi dati scrivendo a privacy@volee-football.com.',
      noticeDraft: 'Bozza: il testo è in revisione presso il consulente privacy.',
      consentsEyebrow: 'I CONSENSI',
      required:
        'Ho letto l’informativa e acconsento al trattamento dei miei dati per valutare questa richiesta.',
      requiredHint: 'Senza questo la richiesta non può essere valutata.',
      contact: 'Volée può contattarmi via e-mail o telefono a proposito di questa richiesta.',
      updates: 'Volée può scrivermi per informarmi sulle novità della piattaforma. Facoltativo.',
      missing: 'Il primo consenso è obbligatorio per continuare.',
      submit: 'Continua',
    },
    review: {
      title: 'Riepilogo',
      description: 'Controlla e invia. Dopo l’invio la richiesta passa a Volée.',
      clubGroup: 'LA SOCIETÀ',
      detailsGroup: 'I TUOI DATI',
      accessGroup: 'ACCESSO E DOCUMENTO',
      edit: 'modifica',
      fullName: 'nome e cognome',
      email: 'e-mail',
      phone: 'telefono',
      access: 'come entrerai',
      accessPassword: 'password',
      document: 'documento',
      consentsPending: 'Se i consensi si ripetono qui in riepilogo o restano solo al passo 5.',
      submit: 'Invia la richiesta',
      failedTitle: 'Invio non riuscito',
      failedBody:
        'Nessuna connessione. I dati compilati restano salvati: riprova quando torni in rete.',
      retry: 'Riprova l’invio',
    },
    done: {
      title: 'Richiesta inviata',
      badge: 'in attesa di approvazione',
      body: 'Il tuo profilo è in attesa di approvazione. Un operatore Volée controlla la richiesta e il documento: la risposta arriva indicativamente entro 48 ore.',
      backToSignIn: 'Torna all’accesso',
    },
    status: {
      eyebrow: 'LA TUA RICHIESTA',
      loading: 'Sto caricando la tua richiesta…',
      failed: 'Non siamo riusciti a leggere la tua richiesta.',
      submittedTitle: 'In attesa',
      submittedBadge: 'in attesa di approvazione',
      submittedBody:
        'La richiesta è arrivata a Volée. Un operatore la controlla insieme al documento: la risposta arriva indicativamente entro 48 ore.',
      receivedTitle: 'Richiesta ricevuta',
      receivedNote: 'tutto quello che serve è arrivato',
      reviewTitle: 'In revisione',
      reviewNote: 'risposta indicativamente entro 48 ore',
      integrationTitle: 'Serve un’integrazione',
      integrationBadge: 'serve un’integrazione',
      integrationBody:
        'La revisione si è fermata su un punto. Sistemato quello, la richiesta torna in revisione.',
      reasonTitle: 'Cosa ha scritto l’operatore',
      integrationUpload: 'Carica un altro documento',
      rejectedTitle: 'Richiesta non accettata',
      rejectedBadge: 'non accettata',
      rejectedBody: 'Volée ha esaminato la richiesta e non può accettarla.',
      approvedTitle: 'Approvato',
      approvedBadge: 'approvato',
      approvedBody:
        'Il tuo profilo è attivo. Da qui entri in Volée come dirigente della tua società.',
      approvedEnter: 'Entra in Volée',
    },
  },

  newPassword: {
    title: 'Scegli la tua password',
    description: 'La password temporanea va sostituita prima di continuare.',
    submit: 'Salva e continua',
    saved: 'Password impostata.',
  },
  mfa: {
    title: 'Inserisci il codice della tua app',
    description: 'Apri l’app di autenticazione e scrivi il codice che mostra per Volée.',
    code: 'Codice',
    submit: 'Accedi',
    cardTitle: 'Verifica in due passaggi',
    cardDescription: 'Un codice da un’app sul telefono, chiesto in aggiunta alla password.',
    statusOn: 'La verifica in due passaggi è attiva.',
    statusOff: 'La verifica in due passaggi non è attiva.',
    lostDeviceTitle: 'Se perdi il telefono',
    lostDevice:
      'Tieni l’app su un telefono che conservi. Se lo perdi non puoi più accedere da solo: scrivici e la disattiviamo noi.',
    enable: 'Attiva la verifica in due passaggi',
    disable: 'Disattiva',
    setupTitle: 'Inquadra il codice',
    setupDescription:
      'Inquadralo con la tua app di autenticazione, oppure digita la chiave a mano. Poi inserisci il codice che l’app mostra.',
    secret: 'Chiave',
    copySecret: 'Copia la chiave',
    secretCopied: 'Chiave copiata',
    unreadable:
      'Ora non riesco a sapere se la verifica in due passaggi è attiva. Riprova più tardi.',
    confirm: 'Conferma e attiva',
    cancel: 'Annulla',
    enabled: 'Verifica in due passaggi attivata.',
    disabled: 'Verifica in due passaggi disattivata.',
  },
  addEmail: {
    email: 'La tua mail',
    emailHint: 'Deve essere tua: da lì entri con quella.',
    confirmEmail: 'Ripeti la mail',
    mismatch: 'Le due mail non coincidono.',
    required: 'Obbligatorio.',
    send: 'Mandami il codice',
    codeSent: 'Abbiamo mandato un codice a {email}: scrivilo qui. Vale un’ora.',
    code: 'Codice',
    confirm: 'Conferma la mail',
    otherEmail: 'Usa un’altra mail',
    done: 'La tua mail è confermata: da ora entri con {email}.',
  },
  passwordReset: {
    title: 'Reimposta la password',
    description: 'Inserisci la tua email. Se esiste un account, arriva un codice per email.',
    email: 'Email',
    request: 'Invia il codice',
    codeTitle: 'Inserisci il codice',
    codeDescription:
      'Se l’indirizzo ha un account, arriva un codice (sotto i 14 anni anche ai tuoi tutori): vale un’ora. Scrivilo e scegli una nuova password.',
    code: 'Codice',
    confirm: 'Salva la nuova password',
    done: 'Password aggiornata.',
    signInYourself: 'Entra con la nuova password.',
    backToSignIn: 'Torna all’accesso',
    identifier: 'Email o nome utente',
    toldTitle: 'Abbiamo scritto ai tuoi tutori',
    toldDescription:
      'Se «{username}» esiste e hai meno di 14 anni, i tuoi tutori con un account hanno ricevuto una mail: la password nuova la sceglie uno di loro, dalla sua pagina.',
    forgotUsernameTitle: 'Non ti ricordi nemmeno il nome utente?',
    forgotUsernameBody: 'Chiedilo al tuo tutore: lo vede sulla tua card, nella sua pagina.',
    limit: 'Al massimo 3 richieste all’ora.',
    noGuardian:
      'Hai già 14 anni, o nessuno dei tuoi tutori ha più un account Volée? Il recupero passa dallo staff di Volée: chiedi alla tua società di scriverci.',
  },
  password: {
    new: 'Nuova password',
    confirm: 'Conferma la nuova password',
    show: 'Mostra la password',
    hide: 'Nascondi la password',
    policyHint: 'Almeno {minLength} caratteri, con una maiuscola, una minuscola e una cifra.',
    mismatch: 'Le due password non coincidono.',
    policy: 'Questa password non rispetta i requisiti indicati sopra.',
    required: 'Campo obbligatorio.',
    rules: 'Requisiti della password',
    ruleMinLength: 'Almeno {minLength} caratteri',
    ruleUppercase: 'Una lettera maiuscola',
    ruleLowercase: 'Una lettera minuscola',
    ruleDigit: 'Una cifra',
    current: 'Password attuale',
    changeTitle: 'Cambia la password',
    changeDescription: 'Qui resti collegato; gli altri tuoi dispositivi non cambiano.',
    changeSubmit: 'Cambia la password',
    changed: 'Password cambiata.',
  },
  placeholder: {
    blocked: 'BLOCCATO',
    toConfirm: 'DA CONFERMARE',
    mockData: 'DATI FINTI',
    mockValue: 'FINTO',
  },
  activation: {
    title: 'Benvenuti su Volée',
    description:
      'La vostra società è stata attivata. Da qui create il vostro accesso: i dati della società li abbiamo già caricati noi, dovrete solo controllarli.',
    club: 'la società',
    invitedPerson: 'invito intestato a',
    stepsTitle: 'TRE PASSI, POI SIETE DENTRO',
    stepPassword: '— Create la password',
    stepDetails: '— Confermate i vostri dati',
    stepClubData: '— Controllate i dati della società',
    start: 'Iniziamo',
    notMe: 'Non sono io',
  },
  wizard: {
    back: '← indietro',
    progress: 'passo {step} di {total}',
    password: {
      title: 'Create la password',
      email: 'e-mail',
      emailHint: 'Dall’invito: è la prova che l’indirizzo è vostro.',
      consent:
        'Accetto le condizioni d’uso e ho letto l’informativa sulla privacy. Il testo esatto è materia del consulente privacy: qui si decide cosa la società accetta entrando in piattaforma.',
      consentRequired: 'Per proseguire dovete accettare.',
      consentPending:
        'Che cosa la società accetta e con quali parole. È il nodo «parlare con DPO» della board, attaccato proprio a questo passaggio.',
      submit: 'Crea l’accesso',
    },
    profile: {
      title: 'I vostri dati',
      description:
        'Chi siete e con che ruolo entrate. Il ruolo determina cosa potete fare in piattaforma.',
      firstName: 'nome',
      lastName: 'cognome',
      nameRequired: 'Campo obbligatorio.',
      email: 'e-mail',
      phone: 'telefono',
      phoneRequired: 'Campo obbligatorio.',
      birthDate: 'data di nascita',
      birthDateRequired: 'Campo obbligatorio.',
      birthDateFuture: 'Questa data non è ancora arrivata.',
      role: 'il vostro ruolo nella società',
      submit: 'Avanti',
    },
    review: {
      title: 'Controllate i vostri dati',
      description:
        'Li abbiamo compilati noi durante l’attivazione. Date un’occhiata: se è tutto giusto, confermate.',
      club: 'LA SOCIETÀ',
      clubReport: 'segnala',
      legalName: 'ragione sociale',
      legalForm: 'forma giuridica',
      registeredOffice: 'sede legale',
      taxCode: 'codice fiscale o P.IVA',
      pec: 'PEC',
      legalRepresentative: 'legale rappresentante',
      contact: 'IL REFERENTE',
      contactEdit: 'modifica',
      contactName: 'nome e cognome',
      contactPhone: 'telefono',
      contactEmail: 'e-mail',
      missingValue: 'Non ancora in anagrafica',
      contractNote:
        'Sede legale e partita IVA sono dati del contratto: per cambiarli serve una segnalazione, non si correggono da qui.',
      confirm: 'Confermo che i dati sono corretti',
      confirmRequired: 'Confermate i dati prima di entrare.',
      enter: 'Entra nella piattaforma',
      reportError: 'Segnala un errore',
    },
    edit: {
      cancel: '← annulla',
      title: 'Il referente',
      description:
        'Una schermata sola, riusata per ogni gruppo: cambia il titolo e cambiano i campi. Quattro o cinque campi per volta, non diciassette.',
      save: 'Salva',
      cancelAction: 'Annulla',
      pending:
        'Quali gruppi la società può correggere da sé. Sede legale e partita IVA cambiano il contratto: la proposta è che passino da una segnalazione, non da questa schermata.',
      saved: 'Dati aggiornati.',
    },
    report: {
      title: 'Che cosa non torna',
      description:
        'Ce ne occupiamo noi e vi ricontattiamo. Nel frattempo potete entrare nella piattaforma: la segnalazione non blocca l’accesso.',
      subject: 'QUALE DATO',
      subjectClub: 'I dati della società',
      subjectPitch: 'L’impianto',
      subjectInfrastructure: 'L’infrastruttura rilevata',
      subjectContact: 'Il referente',
      subjectRequired: 'Scegliete a che cosa si riferisce la segnalazione.',
      description_: 'che cosa c’è di sbagliato',
      descriptionRequired: 'Descrivete che cosa non torna.',
      submit: 'Invia la segnalazione',
      pending: 'A chi arriva la segnalazione e con che canale.',
      noteTitle: 'La segnalazione non blocca l’accesso',
      noteBody:
        'Un dato sbagliato in anagrafica non impedisce di caricare le rose o di guardare le partite: la società entra e noi correggiamo.',
      sent: 'Segnalazione inviata.',
    },
  },
  invitation: {
    signedIn: {
      title: 'Avete aperto l’invito con un accesso attivo',
      otherAddress:
        'L’invito è per {invitedEmail}, mentre in quest’app siete entrati come {currentEmail}. Accettarlo da qui cambierebbe l’account con cui state lavorando: per proseguire dovete uscire, poi riaprite l’invito.',
      invitedAddressLabel: 'invito intestato a',
      currentAddressLabel: 'in quest’app siete',
      signOut: 'Esci e torna all’invito',
      decline: 'Rifiuta l’invito',
      notNow: 'Non ora, torna in Volée',
    },
    expired: {
      title: 'Questo invito è scaduto',
      description:
        'Gli inviti hanno una durata: è una scelta nostra, non un vostro errore. Chiedetene uno nuovo e arriva allo stesso indirizzo.',
      askNew: 'Chiedi un nuovo invito',
      pending:
        'Quanto dura un invito, e a chi arriva la richiesta di rinvio: al referente Volée della società o a un indirizzo di assistenza?',
    },
    used: {
      title: 'Questo invito è già stato usato',
      description:
        'Esiste già un accesso creato con questo invito. Il caso più comune è che l’abbiate creato voi e non ve lo ricordiate.',
      signIn: 'Entra con le tue credenziali',
      forgotPassword: 'Password dimenticata',
      notMe: 'Non sono stato io',
      pending:
        'Se l’invito è stato usato da qualcun altro è un problema di sicurezza, non un intoppo: che cosa accade quando qualcuno lo segnala?',
    },
    revoked: {
      title: 'Questo invito non è più valido',
      description:
        'Volée lo ha annullato. Succede quando è stato mandato all’indirizzo sbagliato, o quando il referente della società è cambiato.',
      pending:
        'Quale canale: telefono del referente, indirizzo di assistenza, o un modulo? La board dice solo «contatta volee».',
    },
    unknown: {
      title: 'Questo link non è valido',
      description:
        'L’indirizzo che avete aperto non è un invito che riconosciamo. Controllate il link nel messaggio che avete ricevuto, o chiedetene uno nuovo.',
    },
    contact: 'Contatta Volée',
    staff: {
      title: 'Vi hanno invitato',
      description:
        'La società vi dà accesso alla piattaforma. Chi vi ha invitato e con che ruolo lo trovate qui sotto: se non torna, non accettate.',
      club: 'la società che vi invita',
      invitedBy: 'chi vi ha invitato',
      role: 'il vostro ruolo',
      teams: 'le squadre che seguirete',
      noTeams: 'Nessuna: è un ruolo di società',
      noTeamYet: 'Nessuna ancora: la società non gliene ha assegnata una',
      accept: 'Accetta l’incarico',
    },
    signIn: {
      title: 'Hai già un account Volée: accedi per accettare l’incarico',
      description: '{club} ti ha invitato come {role}.',
      account: 'il tuo account',
      action: 'Accedi',
      notYou: 'Non sei tu? Chiedi a chi ti ha invitato di usare un altro indirizzo.',
    },
    accept: {
      namesTitle: 'I tuoi dati',
    },
  },
  deadline: {
    at: '{day} alle {time}',
  },
  guardianPage: {
    eyebrow: 'Conferma del tutore',
    heroTitle: '{name} vuole entrare su Volée',
    heroBody:
      '{name} ha {age} anni: sotto i 14 la legge chiede il consenso di chi ne ha la responsabilità genitoriale. Poi decide {club}.',
    validUntil: 'Vale fino a {deadline}',
    born: 'Nato il',
    club: 'Società',
    team: 'Leva',
    noTeam: 'Leva non ancora scelta',
    continue: 'Continua',
    decline: 'Non confermo',
    whoTitle: 'Chi sei',
    whoDescription: 'Ti creiamo un account: ti serve per confermare e decidere per tuo figlio.',
    haveAccount: 'Hai già un account Volée? Entra',
    relationship: 'Chi sei per {name}?',
    relationships: { mother: 'Madre', father: 'Padre', guardian: 'Tutore legale' },
    firstName: 'Nome',
    lastName: 'Cognome',
    phone: 'Telefono',
    email: 'La tua mail',
    emailHint: 'Ti serve per entrare su Volée.',
    password: 'Password',
    agree:
      'Sono il genitore o il tutore legale di {name} e acconsento alla sua registrazione. Ho letto l’informativa privacy.',
    agreeRequired: 'Spunta il consenso per confermare.',
    required: 'Obbligatorio.',
    noticeTitle: 'L’informativa privacy',
    noticeLoading: 'Carico l’informativa…',
    noticeError: 'L’informativa non si è caricata: riprova tra poco.',
    confirm: 'Conferma',
    confirming: 'Confermo…',
    signInTitle: 'Entra',
    signInDescription:
      'Conferma con l’account che hai già: anche da dirigente di società o da allenatore.',
    signInConfirm: 'Entra e conferma',
    signedInAs: 'Sei entrato come {email}.',
    otherAccount: 'Entra con un altro account',
    challenge:
      'Questo account chiede un passaggio in più per entrare: entra dalla pagina di accesso, poi riapri il link.',
    toSignIn: 'Vai all’accesso',
    refuseTitle: 'Non confermi?',
    refuseCalloutTitle: 'La richiesta di {name} si chiude',
    refuseCalloutBody:
      '{club} non potrà approvarla, e {name} lo vedrà sulla sua pagina. Se il link ti è arrivato per sbaglio, puoi anche solo chiudere questa pagina.',
    refuseConfirm: 'Non confermo',
    refuseBack: 'Torna indietro',
    refusedTitle: 'Va bene, nessuna conferma',
    refusedBody:
      'La richiesta di {name} è chiusa. Se cambi idea, {name} può ricominciare e mandarti un nuovo link.',
    doneBadge: 'Confermato',
    doneTitle: 'Fatto, grazie',
    doneBody:
      'Ora decide {club}: vi scriviamo quando approva. Da oggi trovi {name} nella tua pagina.',
    childLoginTitle: '{name} entra con la sua mail',
    childLoginBody: 'E con la password che ha scelto.',
    goToPage: 'Vai alla tua pagina',
    expiredBadge: 'Scaduto',
    expiredTitle: 'Questo link è scaduto',
    expiredBody:
      'Il link valeva fino a {deadline}. Chiedi a {name} di mandartene uno nuovo dalla sua pagina: vale altri 7 giorni.',
    confirmedBadge: 'Già confermato',
    confirmedTitle: 'Ci ha già pensato qualcuno',
    confirmedBody:
      '{who} ha già confermato la registrazione di {name}. Se anche tu sei suo tutore, chiedi il link per un altro tutore: lo manda chi ha confermato, da «Altro tutore» sulla card di {name}.',
    closedBadge: 'Chiusa',
    closedTitle: 'Questa richiesta è chiusa',
    closedBody:
      'Non c’è più niente da confermare. Se serve, {name} può ricominciare e mandarti un nuovo link.',
    notFoundTitle: 'Questo link non esiste',
    notFoundBody: 'Chiedi a chi te l’ha mandato di rimandarlo.',
    childDetail: '{age} anni · {club}',
    next: 'Avanti',
    signInNext: 'Entra',
    accessTitle: 'L’accesso di {name}',
    accessDescription:
      '{name} non ha una mail: entrerà con un nome utente e la password che scegli tu. Li potrai cambiare solo tu, dalla tua pagina.',
    username: 'Nome utente',
    usernameHint:
      'Lo proponiamo noi, e puoi cambiarlo. Lettere, numeri e punto. Non è pubblico: lo vedete solo tu e {name}.',
    usernameRules: 'Se il nome utente è libero',
    usernameFree: '{username} è libero',
    usernameTaken: '{username} è già preso',
    proposalError: 'Non riusciamo a proporre un nome utente: scrivine uno tu.',
    childPassword: 'Password di {name}',
    childPasswordConfirm: 'Ripeti la password',
    childLoginUsernameTitle: '{name} entra con «{username}»',
    childLoginUsernameBody: 'E con la password che hai scelto: diglielo tu.',
    noClub: 'Non ancora tesserato',
    childDetailNoClub: '{age} anni',
    // Il link per un altro tutore (#297): nominato dal figlio, mandato da un suo tutore.
    another: {
      eyebrow: 'Un altro tutore',
      heroTitle: 'Diventa tutore di {name}',
      heroBody:
        '{name} ha {age} anni: sotto i 14 il consenso lo dà chi ne ha la responsabilità genitoriale. Con il tuo account diventi un suo tutore, con gli stessi poteri degli altri. Nessuno di voi potrà togliere l’altro.',
      invitedBy: 'Te lo ha mandato {who}.',
      agree: 'Sono il genitore o il tutore legale di {name}. Ho letto l’informativa privacy.',
      refuseCalloutTitle: 'Non diventi tutore di {name}',
      refuseCalloutBody:
        'Il link si chiude. Se ti è arrivato per sbaglio, puoi anche solo chiudere questa pagina.',
      refusedBody: 'Il link è chiuso. Se cambi idea, chiedi a chi te l’ha mandato un link nuovo.',
      doneTitle: 'Fatto: sei suo tutore',
      doneBody: 'Da oggi trovi {name} nella tua pagina, con gli stessi poteri degli altri tutori.',
      expiredBody:
        'Il link valeva fino a {deadline}. Chiedi a chi te l’ha mandato di mandartene uno nuovo: vale altri 7 giorni.',
      confirmedTitle: 'Questo link è già stato usato',
      confirmedBody:
        '{who} lo ha già usato. Se anche tu sei tutore di {name}, chiedi a un suo tutore un link nuovo da «Altro tutore».',
      closedTitle: 'Questo link non chiede più niente',
      closedBody: 'Non c’è più niente da confermare per {name}.',
    },
  },
  guardianConfirmation: {
    relationship: { mother: 'madre', father: 'padre', guardian: 'tutore legale' },
    who: '{name} ({relationship})',
    confirmedOn: 'ha confermato il {date} alle {time}',
  },
  enrolment: {
    title: 'Iscrivi un giocatore',
    invalidTitle: 'Questo link non è più valido',
    invalidDescription: 'Chiedine uno nuovo a chi te l’ha mandato.',
    progress: 'passo {step} di {total}',
    pickClub: {
      title: 'La tua società',
      description: 'Cerca la società in cui giochi tu, o tuo figlio.',
      start: 'Iniziamo',
    },
    search: {
      title: 'Cerca il tuo giocatore',
      description: 'Bastano pochi dati per controllare se è già in rosa.',
      firstName: 'nome',
      lastName: 'cognome',
      birthDate: 'data di nascita',
      firstNameRequired: 'Campo obbligatorio.',
      lastNameRequired: 'Campo obbligatorio.',
      birthDateRequired: 'Campo obbligatorio.',
      submit: 'Cerca',
      searching: 'Ricerca in corso…',
      failed: 'La ricerca non è andata a buon fine.',
      retry: 'Riprova',
    },
    result: {
      matchedTitle: 'Giocatore trovato',
      matchedDescription:
        '{name} è già nella rosa della società ma non ha ancora un accesso: continua per dargliene uno. La società approverà la richiesta.',
      continue: 'Continua',
      searchAgain: '← cerca di nuovo',
    },
    alreadyRostered: {
      title: 'Questo giocatore è già nella società',
      body: '{name} è già nella rosa della società, quindi non serve iscriverlo di nuovo. Se pensi sia un errore, contatta la società.',
      searchAgain: 'Cerca di nuovo',
    },
    playerData: {
      title: 'I dati di {name}',
      description: 'Controlla i dati e scegli il sesso: servono per il tesseramento.',
      recapLabel: 'I dati della ricerca',
      birthLine: 'Data di nascita: {date}',
      edit: 'Modifica',
      sex: 'Sesso',
      sexMale: 'Maschio',
      sexFemale: 'Femmina',
      sexRequired: 'Scegli il sesso.',
      missing: 'Scegli il sesso per continuare.',
      submit: 'Continua',
    },
    consents: {
      title: 'Privacy e consensi',
      noticeTitle: 'L’informativa',
      agree:
        'Ho letto l’informativa e acconsento al trattamento dei dati miei e di {name} per l’iscrizione alla società.',
      agreeRequired: 'Spunta il consenso per inviare la richiesta.',
      noticeLoading: 'Carico l’informativa…',
      noticeError: 'L’informativa non si carica: riprova tra poco.',
      next: 'Continua',
      submit: 'Invia la richiesta',
      submitting: 'Invio…',
    },
    childDetails: {
      title: 'Come entrerà {name}',
      description: 'Con la sua mail, se ce l’ha. Altrimenti l’accesso lo crea il tutore.',
      email: 'mail di {name}',
      emailHint: 'Deve essere sua, non quella del tutore.',
      confirmEmail: 'ripeti la mail',
      phone: 'il suo telefono',
      hasEmail: '{name} ha una mail sua?',
      hasEmailYes: 'Sì',
      hasEmailNo: 'No',
      helpTitle: 'Fatti aiutare da un genitore',
      helpBody:
        'Senza una mail, l’accesso di {name} lo crea il suo tutore quando conferma: il nome utente e la password li sceglie il tutore, e solo il tutore potrà cambiarli.',
    },
    guardianLink: {
      title: 'Chi conferma per {name}?',
      description: '{name} ha meno di 14 anni: serve il sì di un genitore o di un tutore.',
      here: { title: 'È qui con me', detail: 'Conferma adesso, da questo telefono.' },
      send: {
        title: 'Mando il link al tutore',
        detail: 'Il tutore riceve un link: conferma quando può, entro 7 giorni.',
      },
      eyebrow: 'Link per il tutore',
      validUntil: 'Vale fino a {deadline}',
      share: 'Condividi',
      whatsApp: 'Invia su WhatsApp',
      copy: 'Copia link',
      copied: 'Link copiato',
      message:
        'Ciao! Per entrare su Volée mi serve la tua conferma, perché ho meno di 14 anni: {link}',
      done: 'Fatto, aspetto',
    },
    // «Aggiungi un figlio»: the tutore is already inside, so the yes is theirs as the request leaves.
    guardianConfirm: {
      title: 'Conferma per {name}',
      description:
        '{name} ha meno di 14 anni: serve il sì di un genitore o di un tutore. Sei dentro con il tuo account, quindi lo dai tu adesso.',
      submit: 'Conferma e invia',
      submitting: 'Invio…',
    },
    playerDetails: {
      title: 'I tuoi dati',
      description: '{name} ha 14 anni o più, quindi invia la richiesta da solo.',
      email: 'la tua e-mail',
      emailHint: 'La società risponde a questo indirizzo.',
      emailRequired: 'Campo obbligatorio.',
      confirmEmail: 'conferma la tua e-mail',
      confirmEmailRequired: 'Campo obbligatorio.',
      emailMismatch: 'Le e-mail non coincidono.',
      phone: 'il tuo telefono',
      alreadyThereTitle: 'Sei già dei nostri',
      inUseTitle: 'Questa mail ha già un account',
      inUseBody:
        'Non diciamo di chi è. Se è tua, entra. Se non hai una mail tua, continua senza: l’accesso lo crea il tuo tutore.',
      withoutMail: 'Continua senza mail',
      inUseForAChild: 'Questa mail ha già un account: scrivine una che sia solo di tuo figlio.',
      signIn: 'Vai all’accesso',
      submit: 'Continua',
    },
    review: {
      title: 'Controlla e invia',
      description: 'Una volta inviata, la richiesta arriva alla società.',
      playerGroup: 'IL GIOCATORE',
      requesterGroup: 'I TUOI DATI',
      firstName: 'nome',
      lastName: 'cognome',
      birthDate: 'data di nascita',
      relationship: 'relazione',
      email: 'e-mail',
      phone: 'telefono',
      edit: 'modifica',
      submit: 'Invia la richiesta',
      failed: 'L’invio non è andato a buon fine.',
      retry: 'Invia di nuovo',
    },
    status: {
      eyebrow: 'LA REGISTRAZIONE',
      loading: 'Sto caricando la richiesta…',
      failed: 'Non siamo riusciti a leggere la richiesta.',
      stagesEyebrow: 'La registrazione di {name}',
      stagesLabel: 'Le tappe della registrazione',
      stageDone: 'fatto',
      stageCurrent: 'in corso',
      stageTodo: 'da fare',
      stageFailed: 'non riuscita',
      stageSignUp: 'Registrazione',
      stageSignUpBody: 'Il tuo account è pronto.',
      stageSignUpNoAccessBody: 'La tua richiesta è partita: l’accesso lo crea il tuo tutore.',
      stageSignUpOwnAccessBody: 'La tua richiesta è partita.',
      stageGuardian: 'Conferma del tutore',
      stageClub: 'Approvazione di {club}',
      stageGuardianDone: '{who} ha confermato il {date}.',
      awaitingGuardianTitle: 'Aspettiamo il tuo tutore',
      awaitingGuardianBody: 'Quando conferma, {club} vede la tua richiesta e può approvarla.',
      ownAccessTitle: 'Da oggi decidi tu',
      ownAccessStage: 'La tua mail',
      ownAccessBody:
        'Hai compiuto 14 anni: non serve più il tuo tutore. Aggiungi una mail tua e scegli una password: è il tuo accesso, e la richiesta passa alla società.',
      ownAccessConfirm: 'Conferma ed entra',
      expiredTitle: 'Il link è scaduto',
      expiredBody:
        'Il tuo tutore non ha confermato in 7 giorni. Manda un nuovo link: vale altri 7 giorni.',
      declinedTitle: 'Il tuo tutore non ha confermato',
      declinedBody:
        'La richiesta si è chiusa. Se è stato un errore, parlane con il tutore e ricomincia: arriva un link nuovo.',
      dataDeletedOn: 'Se nessuno conferma, i tuoi dati si cancellano {date}.',
      sendAgain: 'Manda un nuovo link',
      startAgain: 'Ricomincia',
      submittedTitle: 'Aspettiamo la società',
      submittedBody:
        '{club} controlla la richiesta e decide sulla registrazione di {name}: ti scriviamo quando lo fa.',
      reasonTitle: 'Cosa ha scritto la società',
      rejectedTitle: 'Richiesta non accettata',
      rejectedBadge: 'non accettata',
      rejectedBody: '{club} ha esaminato la richiesta per {name} e non può accettarla.',
      approvedTitle: 'Registrazione approvata',
      approvedBadge: 'approvata',
      approvedBody: '{club} ha approvato la registrazione di {name}. Da qui entri in Volée.',
      approvedEnter: 'Entra in Volée',
    },
  },
  club: {
    title: 'Società',
    description: 'Area protetta: visibile solo ai ruoli abilitati.',
    noSelection: 'Nessuna società selezionata.',
  },
  clubPage: {
    notFound: 'Questa società non esiste.',
  },
  official: {
    back: 'dashboard',
    mock: 'Nessun endpoint serve ancora questo dato.',
    chooseClub: {
      title: 'Quale società?',
      description: 'Avete un incarico in più di una. Scegliete quella da aprire.',
    },
    dashboard: {
      title: 'La vostra società',
      countPlayers: 'Tesserati',
      countSquads: 'Squadre',
      countPitches: 'Campi',
      countUnavailable: 'Non disponibile',
      kitsLink: 'Le divise',
      kitsInvitation: 'Con che colori giocate?',
      kitsInvitationDetail: 'Impostatele una volta: la convocazione proporrà quella giusta.',
      kitsInvitationAction: 'Imposta la prima divisa',
      nextMatches: 'CALENDARIO PARTITE',
      noNextMatches: 'Nessuna partita in calendario.',
      matchSummary: '{date} · {home} — {away}',
      squads: 'LE SQUADRE',
      squadsCount: 'quante sono',
      allSquads: 'Vedi tutte le squadre',
      squadPlace: '{position}° posto',
      squadPlaceIn: '{position}° posto · Girone {code}',
      allMatches: 'Vedi tutte le partite',
      allPlayers: 'Vedi tutti gli atleti',
      organigramma: 'ORGANIGRAMMA',
      organigrammaNote:
        'Chi c’è dietro la società: a un genitore che valuta dice più di una statistica.',
      officials: 'DIRIGENTI DI SOCIETÀ',
      staffBySquad: 'STAFF PER CATEGORIA',
      waitingForSquad: 'In attesa di squadra',
      adults: '{count} adulti',
      oneAdult: '1 adulto',
      noCoach: 'Ancora nessun allenatore.',
      seasonCurrent: 'stagione in corso',
      seasonPrevious: 'stagione precedente',
      pitches: 'I CAMPI',
      noPitches: 'Nessun campo è ancora collegato alla vostra società.',
      noPitchesOfThisClub: 'Nessun campo è ancora collegato a questa società.',
      individual: 'RICONOSCIMENTI INDIVIDUALI',
      individualNote:
        'Atleti chiamati da squadre professionistiche o selezionati per rappresentative.',
      allDone: 'Tutto pronto',
      noRecording: 'Una partita senza ripresa',
      noRecordingBody:
        'Su quale campo, e da quando. Le partite giocate in questi giorni potrebbero non essere state riprese.',
      lastMatches: 'ULTIME PARTITE CARICATE',
    },
    people: {
      title: 'Staff',
      listTitle: 'LE PERSONE',
      accounts: 'GLI ACCOUNT',
      accountsManagement: '{count} di gestione',
      accountsSquad: '{count} di squadra',
      accountsCounted: 'Contano gli account attivi: un invito conta quando è accettato.',
      filterAll: 'tutti',
      filterAdmin: 'chi amministra',
      filterCoach: 'chi è in panchina',
      hasAccount: 'attivo',
      pendingTitle: 'Inviti in attesa',
      pendingState: 'In attesa',
      expiredState: 'Scaduto',
      offerExpires: 'scade il {date}',
      offerExpired: 'scaduto il {date}',
      resend: 'Rimanda',
      resent: 'Invito rimandato a {email}',
      resentNotEmailed: 'Invito rimandato, ma la mail non è partita: riprova più tardi.',
      revoke: 'Revoca',
      revokeTitle: "Revocare l'invito a {email}?",
      revokeBody:
        'Il link smetterà di funzionare. L’invito non ha ancora dato nessun ruolo: potete invitare di nuovo lo stesso indirizzo quando volete.',
      revoked: 'Invito revocato',
      unseatedTitle: 'Squadre senza nessuno nei posti',
      unseatedBody:
        '{squads}. Finché nessuno vi occupa un posto, rosa, convocazioni e divise le gestite voi.',
      invite: 'Invita una persona',
      empty: 'Nessuno ha ancora un incarico qui.',
    },
    invite: {
      title: 'Invita una persona',
      description: 'Accetterà da un link, e i suoi dati li scrive lui.',
      close: 'Chiudi',
      email: 'Email',
      emailNote: "L'invito arriva qui, ed è ciò che prova che l'indirizzo è suo.",
      emailOfTheHolder:
        'L’indirizzo che la società ha di questa persona: l’invito le dà l’account.',
      titleEntry: 'Invita a entrare',
      descriptionEntry:
        '{name} tiene già il posto: l’invito dà l’account con cui entrare, e non occupa un altro posto.',
      role: 'Ruolo',
      roleOfficial: 'Dirigente di società',
      roleCoach: 'Allenatore',
      descriptionOnto:
        'Su un posto della squadra {squad}. Accetterà da un link, e i suoi dati li scrive lui.',
      officialsFull:
        'I posti di società sono occupati: chiudete l’incarico di un dirigente di società per invitarne un altro.',
      squadsFull:
        'Ogni squadra ha i posti occupati: togliete qualcuno da una squadra per invitare un allenatore o un dirigente di squadra.',
      team: 'Squadra',
      pickTeam: 'Scegliete la squadra',
      teamNote: 'Si invita solo su un posto libero: qui ci sono le squadre che ne hanno uno.',
      submit: "Manda l'invito",
      sending: 'Invio in corso…',
      cancel: 'Annulla',
      sent: 'Invito inviato a {email}',
      notEmailed: 'Invito creato, ma la mail non è partita: rimandalo dalla lista.',
    },
    person: {
      back: 'le persone',
      data: 'I SUOI DATI',
      heldIncarichi: 'GLI INCARICHI CHE HA',
      endIncarico: 'chiudi',
      endTitle: 'Chiudere l’incarico di {role} di {name}?',
      endTeamTitle: 'Chiudere l’incarico di {role} di {name} per la squadra {squad}?',
      endBody: 'Se è il suo ultimo incarico, non entra più nella società su Volée.',
      endYes: 'Chiudi',
      removed: 'Incarico concluso',
      addIncarico: 'AGGIUNGI UN INCARICO',
      addNote: 'Assegnare non è invitare: questo dà un ruolo, non un account.',
      officialsFull:
        'I posti di società sono occupati: chiudete l’incarico di un dirigente di società per darne un altro.',
      team: 'Squadra (facoltativa)',
      teamNone: 'Nessuna squadra per ora',
      place: 'Nella squadra',
      placeSeat: 'Posto di squadra',
      placeStaff: 'Senza posto',
      seatsFull:
        'I posti di questa squadra sono occupati: la persona entra nello staff della squadra, senza posto.',
      seatHeld:
        'Questa persona ha già un posto su questa squadra: con questo ruolo entra nello staff, senza posto.',
      officialNoSeat:
        'Un dirigente di società entra nello staff della squadra senza posto: la gestisce già.',
      seatMark: 'Posto di squadra',
      addSubmit: 'Aggiungi l’incarico',
      adding: 'Aggiunta in corso…',
      added: 'Incarico aggiunto',
      asCoach: 'COME ALLENATORE · LE SUE SQUADRE',
      asTeamOfficial: 'COME DIRIGENTE DI SQUADRA · LE SUE SQUADRE',
      asBench: 'IN PANCHINA · LE SUE SQUADRE',
      noSquadHere: 'Non allena ancora nessuna squadra qui',
      noSquadHereAsTeamOfficial: 'Non è ancora dirigente di nessuna squadra qui',
      noSquadHereAsBench: 'Non è ancora in panchina in nessuna squadra qui',
      unseatedSquads: 'SQUADRE SENZA NESSUNO NEI POSTI',
      remove: 'togli',
      assign: 'assegna',
      inChargeSince: 'in carica da',
      inChargeSinceSeason: 'in carica da questa stagione {date}',
      fieldName: 'nome e cognome',
      fieldNameValue: 'dall’invito',
      fieldEmail: 'e-mail',
      fieldEmailHint: 'non modificabile: è l’identità dell’account',
      fieldTaxCode: 'codice fiscale',
      fieldTaxCodeHint: 'lo corregge Volée',
      fieldPhone: 'telefono',
      actOnSquad: '{action} — {squad}',
      actOnIncarico: '{action} — {role} · {squad}',
      notFound: 'Questa persona non lavora con la vostra società.',
    },
    club: {
      title: 'I dati della società',
      description: 'Controllate i vostri dati, e correggeteli.',
      back: 'la vostra società',
      identity: 'LA SOCIETÀ',
      fieldLegalName: 'ragione sociale',
      fieldShortName: 'nome d’uso',
      fieldAddress: 'sede legale',
      fieldRegion: 'regione',
      fieldProvince: 'provincia',
      chooseRegion: 'Scegliete una regione',
      chooseProvince: 'Scegliete una provincia',
      chooseRegionFirst: 'Scegliete prima la regione',
      noProvince: 'Non registrata',
      noAddress: 'non registrata',
      voleeOwns:
        'Ragione sociale, nome d’uso e questo indirizzo li cambiamo noi: scriveteci e lo facciamo.',
      edit: 'Modifica i dati',
      save: 'Salva',
      saved: 'Provincia salvata.',
      crest: 'LO STEMMA',
      crestAlt: 'Lo stemma di {club}',
      crestNote: 'È ciò da cui i genitori vi riconoscono, in ogni pagina del prodotto.',
      logoUpload: 'Scegli un file',
      logoReplace: 'Sostituisci',
      logoRemove: 'Rimuovi',
      logoSaved: 'Stemma salvato.',
      logoRemoved: 'Stemma rimosso.',
      logoTooLarge: 'Il file supera {maxMb} MB.',
      cover: 'LA COPERTINA',
      coverNote:
        'Una foto orizzontale, col soggetto al centro: la vostra pagina la taglia da sé, per il telefono e per il computer, come vedete qui.',
      coverPhone: 'Telefono',
      coverWide: 'Computer',
      coverUpload: 'Scegli una foto',
      coverReplace: 'Sostituisci',
      coverRemove: 'Rimuovi',
      coverSaved: 'Copertina salvata.',
      coverRemoved: 'Copertina rimossa.',
      coverTooLarge: 'Anche ridotta, la foto supera {maxMb} MB: sceglietene un’altra.',
      coverUnreadable: 'Quel file non si apre come immagine: sceglietene un altro.',
      notFound: 'Questa società non esiste.',
      noClub: 'Non avete un incarico in nessuna società, quindi non c’è niente da mostrare.',
      loadError: 'Non è stato possibile caricare i dati della società.',
    },
    pitches: {
      title: 'I vostri campi',
      list: 'I CAMPI SU CUI GIOCATE',
      empty: 'Nessun campo è collegato alla vostra società.',
      listError: 'I campi non si sono potuti caricare.',
      primary: 'principale',
      camera: 'Telecamera',
      cameraSince: 'dal {date}',
      noCamera: 'nessuna telecamera',
      software: 'Software',
      softwareDated: 'del {date}',
      softwareUnknown: 'non ancora comunicato',
    },
    players: {
      title: 'Giocatori',
      addPlayer: 'Aggiungi giocatore',
      searchLabel: 'Cerca per nome',
      filters: 'Filtri',
      clearFilters: 'Azzera',
      resultCount: '{count} giocatori',
      resultCountOne: '{count} giocatore',
      groupTeam: 'Leva',
      allTeams: 'Tutte',
      withoutTeam: 'Senza squadra',
      groupPosition: 'Ruolo',
      allPositions: 'Tutti',
      groupYear: 'Annata',
      allYears: 'Tutte',
      groupAccount: 'Account',
      allAccounts: 'Tutti',
      withAccount: 'Con account',
      withoutAccount: 'Senza account',
      groupStatus: 'Stato',
      statusActive: 'Attivi',
      statusReleased: 'Svincolati',
      statusAll: 'Tutti',
      statusAllChip: 'Attivi e svincolati',
      listLabel: 'Il registro dei giocatori',
      released: 'Svincolato',
      sortLabel: 'Ordina per',
      sortLastNameAsc: 'Cognome (A–Z)',
      sortLastNameDesc: 'Cognome (Z–A)',
      sortBirthDateDesc: 'Dai più giovani',
      sortBirthDateAsc: 'Dai più grandi',
      empty: 'Nessun giocatore è ancora tesserato con questa società.',
      emptySearch: 'Nessun giocatore corrisponde a ricerca e filtri.',
      clearAll: 'Azzera ricerca e filtri',
      loading: 'Caricamento dei giocatori…',
      listError: 'I giocatori non si sono potuti caricare.',
      paginationLabel: 'paginazione dei giocatori',
    },
    requests: {
      title: 'Le richieste delle famiglie',
      description:
        'Finché una richiesta non è evasa, quel ragazzo ha un profilo limitato: non vede i suoi highlight.',
      empty: 'Nessuna richiesta in attesa.',
      rowDetail: 'nato il {birthDate} · {team}',
      matched: 'già in anagrafica',
      awaitingGuardian: 'In attesa del tutore',
      awaitingOwnMail: 'Aspetta la sua mail',
      linkExpires: 'Il link scade {deadline}',
      waitsForOwnMail: 'Ha 14 anni: il tutore non serve più',
      groupToApprove: 'Da approvare',
      groupAwaitingOwnMail: 'In attesa della sua mail',
      groupAwaitingOwnMailNote:
        'Hanno compiuto 14 anni: non serve più il tutore, e la richiesta si approva quando hanno una mail loro.',
      groupAwaitingGuardian: 'In attesa del tutore',
      groupAwaitingGuardianNote: 'Sotto i 14 anni si approva dopo la conferma di un tutore.',
      groupClosed: 'Chiuse senza conferma',
      expired: 'Scaduta',
      expiredDetail: 'Il tutore non ha confermato in 7 giorni',
      declined: 'Non confermata',
      declinedDetail: 'Il tutore ha detto no',
      back: 'le richieste',
      backToDetail: 'la richiesta',
      notFound: 'Questa richiesta non esiste più.',
      approve: 'Approva',
      reject: 'Rifiuta',
      rejectTitle: 'Rifiuta la richiesta',
      rejectWarningTitle: 'Chi ha fatto richiesta riceve quello che scrivete',
      rejectWarningBody: 'Serve un motivo: senza, chi ha sbagliato un dato non sa come rimediare.',
      rejectMessage: 'il messaggio che riceverà',
      rejectSend: 'Invia il rifiuto',
      sectionPlayer: 'Giocatore',
      sectionConsent: 'Consenso',
      sectionTeam: 'Leva',
      sex: 'Sesso',
      taxCode: 'Codice fiscale',
      birthDate: 'Data di nascita',
      age: '{age} anni',
      phone: 'Telefono',
      email: 'Email',
      hasAccount: 'ha già un account',
      alreadyOnFile: 'già in anagrafica',
      consentGiven: 'Dato il {date} alle {time} · informativa versione {version}',
      consentMissing: 'Consenso non registrato (richiesta anteriore al rilascio)',
      noTeam: 'Nessuna leva',
      teamChange: 'Oggi è in {current}: approvando passa a {chosen}',
      todayInTeam: 'Oggi: {team}',
      requestFor: 'Richiesta per {team} · inviata il {date}',
      requestSent: 'Richiesta inviata il {date}',
      declaration:
        'Confermo che i dati che sto approvando, tra cui i dati del giocatore e dei tutori, sono corretti e coerenti con la documentazione registrata dalla società.',
      declarationRequired: 'Spunta la dichiarazione per approvare.',
      notYetTitle: 'Non si può ancora approvare',
      notYetBody:
        'Ha meno di 14 anni: serve prima la conferma del tutore, che ha tempo fino a {deadline}.',
      notYetBodyNoDeadline: 'Ha meno di 14 anni: serve prima la conferma del tutore.',
      notYetOwnAccess:
        'Ha compiuto 14 anni: si approva quando avrà aggiunto una mail sua dalla pagina della richiesta.',
      closedOutcome: 'Chiusa senza la conferma del tutore',
      declaredByFamily: 'dichiarato dalla famiglia',
      approvedOutcome: 'Approvata',
      approvedOn: 'il {date}',
      rejectedOutcome: 'Rifiutata',
      rejectedReason: 'Motivo: {reason}',
      sectionGuardian: 'Tutore',
      guardianNotNeeded: 'Non serve: ha almeno 14 anni',
      guardianPending: 'Non ha ancora confermato',
      rowConfirmedBy: 'Confermata da {who}',
      correctBirthDate: 'Correggi la data di nascita',
      correctSave: 'Salva la data',
      correctCancel: 'Annulla',
      corrected: 'Data di nascita corretta.',
      correctedBackToGuardian:
        'Data corretta: sotto i 14 anni la richiesta aspetta il tutore, e {name} trova un nuovo link sulla sua pagina.',
    },
    player: {
      notFound: 'Questo giocatore non è tesserato con la vostra società.',
      listError: 'Il giocatore non si è potuto caricare.',
      registrations: 'TESSERAMENTI',
      noRegistrations: 'Nessun tesseramento risulta per questa persona.',
      active: 'in corso',
      releasedOn: 'svincolato il {date}',
      noTeam: 'nessuna squadra',
      teamsTitle: 'Squadre — {club} — {season}',
      teamsSaved: 'Squadre salvate.',
      teamsSave: 'Salva',
      teamsCancel: 'Annulla',
      teamsNone: 'Nessuna squadra',
      teamsEmpty: 'Questa società non ha ancora squadre.',
      teamsListError: 'Le squadre non si sono potute caricare.',
      // The scheda's own casing: lowercase, like nome e cognome / e-mail / codice
      // fiscale / telefono above it — apps/frontend/docs/quattro-profili-sotto-me.md.
      position: 'ruolo in campo',
      positionPlaceholder: 'Nessun ruolo assegnato',
      foot: 'piede',
      footPlaceholder: 'Non dichiarato',
      nationality: 'nazionalità',
      nationalityPlaceholder: 'Non dichiarata',
    },
    newPlayer: {
      title: 'Aggiungi giocatore',
      description:
        'Digita qui sotto i dati del giocatore. Se la persona è già in anagrafica, il server la riconosce da nome, cognome e data di nascita: non serve nessuna ricerca.',
      close: 'Chiudi',
      lastName: 'Cognome',
      firstName: 'Nome',
      birthDate: 'Data di nascita',
      birthDateHelp: 'Insieme a nome e cognome identifica la persona.',
      sex: 'Sesso',
      sexPlaceholder: 'Scegli',
      taxCode: 'Codice fiscale',
      taxCodeHelp: 'Facoltativo. Sedici caratteri, come sulla tessera sanitaria.',
      position: 'Ruolo',
      positionPlaceholder: 'Non indicato',
      phone: 'Telefono',
      email: 'Email',
      submit: 'Tessera il giocatore',
      submitting: 'Tesseramento in corso…',
      cancel: 'Annulla',
      required: 'Obbligatorio',
      registered: '{name} tesserato.',
    },
  },
  myCoach: {
    title: 'La tua panchina',
    description: 'Gli incarichi di panchina che ricopri, squadra per squadra.',
    appointments: 'I TUOI INCARICHI',
    noAppointments: 'Nessun incarico di panchina attualmente ricoperto.',
    team: 'squadra {id}',
    teamKits: 'Le divise della squadra',
    noTeam: 'Nessuna squadra',
  },
  // La riga di chi è nello staff senza un posto (spec #366): dice perché la squadra non si apre.
  noSeat: {
    onSquad: 'Sei nello staff della squadra {squad} di {club}, senza posto',
    onClub: 'Sei nello staff di {club}, senza posto',
    ask: 'L’accesso lo dà il dirigente di società: chiedigli un posto.',
  },
  myParent: {
    title: 'La tua famiglia',
    description:
      'I tuoi figli: quelli di cui sei tutore, e quelli che segui da quando hanno 14 anni.',
    minors: 'I TUOI FIGLI',
    addChild: 'Aggiungi un figlio',
    childProfile: 'Il suo profilo',
    taxCodeMissing: 'Codice fiscale non indicato',
    noMinors: 'Non hai ancora aggiunto un figlio.',
    requests: 'LE TUE RICHIESTE',
    requestPending: 'In attesa della società',
    requestDetail: '{club} · richiesta del {date}',
    childGuardian: 'Tutore',
    childGuardianWhy: 'Ha meno di 14 anni: sei il suo tutore.',
    childFollowed: 'Lo segui',
    childFollowedWhy:
      'Ha compiuto 14 anni il {date}: ora il profilo lo gestisce lui. Lo vedi finché non ti toglie.',
    childFollowedOf: 'Ora il profilo lo gestisce lui. Lo vedi finché non ti toglie.',
    anotherGuardian: 'Altro tutore',
    anotherGuardianTitle: 'Un altro tutore per {name}',
    anotherGuardianBody:
      'Manda questo link all’altro genitore: con un suo account diventa tutore di {name} come te. Nessuno dei due potrà togliere l’altro.',
    anotherGuardianEyebrow: 'Link per il tutore',
    anotherGuardianValidUntil: 'Vale fino a {deadline}',
    anotherGuardianShare: 'Condividi',
    anotherGuardianWhatsApp: 'Invia su WhatsApp',
    anotherGuardianCopy: 'Copia link',
    anotherGuardianCopied: 'Link copiato',
    anotherGuardianMessage:
      'Ciao! Ti mando il link per diventare tutore di {name} su Volée: {link}',
    anotherGuardianClose: 'Chiudi',
    childAge: '{age} anni',
    childWithUsername:
      'Ha meno di 14 anni: sei il suo tutore. Non ha una mail ed entra col nome utente «{username}»: se dimentica la password, la reimposti tu.',
    access: 'Accesso',
    accessTitle: 'L’accesso di {name}',
    accessBody:
      '{name} entra senza mail, col nome utente e la password che scegli tu. Li cambi solo tu.',
    accessUsername: 'Nome utente',
    accessUsernameHint: 'Lettere, numeri e punto, da 4 a 20. Non è pubblico.',
    accessPasswordHint: 'Lasciala vuota per tenere la password di ora.',
    accessSave: 'Salva',
    accessSaved: 'L’accesso di {name} è aggiornato.',
    accessClose: 'Chiudi',
    accessNothing: 'Cambia il nome utente o scrivi una password nuova.',
    thisPhone: 'Usa questo telefono anche per {name}',
    thisPhoneTitle: 'Questo telefono anche per {name}',
    thisPhoneBody:
      'Aggiungi {name} a questo telefono: poi passi dal tuo account al suo dal menu con la tua foto, in alto a destra, senza la sua password.',
    thisPhoneProtectedTitle: 'Le cose importanti chiedono la tua password',
    thisPhoneProtectedBody:
      'Confermare, cambiare la privacy di {name}, il piano, il suo accesso e invitare un altro tutore: anche se il telefono è aperto sul tuo account, servirà la tua password.',
    thisPhoneAdd: 'Aggiungi {name} a questo telefono',
    thisPhoneAdded: '{name} è su questo telefono: ci passi dal menu.',
    thisPhoneSwitch: 'Passa a {name}',
    thisPhoneClose: 'Chiudi',
  },
  passwordCheck: {
    title: 'Reinserisci la tua password',
    body: 'Quello che decidi per tuo figlio chiede di nuovo la tua password. Dopo averla data, per qualche minuto non te la richiediamo.',
    label: 'La tua password',
    confirm: 'Conferma',
    confirming: 'Controllo…',
    cancel: 'Annulla',
    close: 'Chiudi',
  },
  addChild: {
    title: 'Aggiungi un figlio',
    description:
      'La registrazione di tuo figlio, con la sua mail e una password sua. Sei già dentro, quindi la confermi tu mentre la invii.',
    backToFamily: 'la tua famiglia',
  },
  // Shared by the two schede that draw this form; the field labels live at each surface's
  // own catalogue instead — apps/frontend/docs/quattro-profili-sotto-me.md.
  playerFacts: {
    nationalitySearch: 'Cerca una nazione',
    nationalityEmpty: 'Nessuna nazione con questo nome',
    edit: 'Correggi i dati',
    save: 'Salva',
    cancel: 'Annulla',
    saved: 'Dati salvati.',
  },
  // Le righe che su `/me/player` danno del tu. Su `/players/$personId` parlano di
  // qualcun altro, quindi la voce cambia e il resto di `myPlayer` resta uno.
  otherPlayer: {
    editProfile: 'Modifica il suo profilo',
    privacyTitle: 'Chi vede il suo profilo',
    privacyClosedLine: 'Fuori da chi ha un posto nella sua società nessuno lo apre.',
    privacyRecord: 'la sua scheda',
    privacyClub: 'la sua squadra',
    privacyCareer: 'la sua carriera',
    privacyPhoto: 'la sua foto',
    privacyStats: 'le statistiche delle sue partite',
    privacyAlways: 'Chi ha un posto nella sua società vede sempre tutto.',
    privacyPreview: 'Vedi come lo vedono',
    notRegistered: 'Non risulta tesserato con nessuna società in questa stagione.',
    recordTitle: 'La sua scheda',
    careerTitle: 'La sua carriera',
    careerLabel: 'Ogni società in cui è stato tesserato',
  },
  player: {
    profileNotPublic: 'Questo giocatore non mostra il proprio profilo.',
  },
  myPlayer: {
    backToPlayers: 'i giocatori',
    toTheRecord: 'Vedi i dati del tesseramento',
    backToRoster: 'la rosa',
    backToTeam: 'la squadra',
    notFound: 'Questo giocatore non esiste.',
    title: 'Il tuo profilo',
    toClub: 'Vai alla società {club}',
    notRegistered: 'Non risulti tesserato con nessuna società in questa stagione.',
    lastMatchTitle: 'Ultima partita',
    nextMatchTitle: 'Prossima partita',
    score: 'Risultato',
    lastMatchEyebrow: 'Giornata {matchday} · {day}',
    versus: 'vs {club}',
    calledUp: 'Convocato · N. {number}',
    calledUpNoNumber: 'Convocato',
    replyComing: 'Ci sono',
    replyNotComing: 'Non ci sono',
    replyOpen: 'Rispondi',
    privacyTitle: 'Chi vede il tuo profilo',
    privacyOpen: 'Aperto',
    privacyClosed: 'Chiuso',
    privacyClosedLine: 'Fuori da chi ha un posto nella tua società nessuno lo apre.',
    privacyOpenNothing: 'Chiunque su Volée lo apre, ma non vede nessuna sezione.',
    privacyOpenShows: 'Chiunque su Volée vede {sections}.',
    privacyRecord: 'la tua scheda',
    privacyClub: 'la tua squadra',
    privacyCareer: 'la tua carriera',
    privacyPhoto: 'la tua foto',
    privacyStats: 'le statistiche delle tue partite',
    privacyAlways: 'Chi ha un posto nella tua società vede sempre tutto.',
    privacyChange: 'Cambia',
    privacyPreview: 'Vedi come ti vedono',
    familyTitle: 'Account e famiglia',
    familyPrompt: 'Un altro figlio da iscrivere?',
    familyAction: 'Iscrivi un ragazzo',
    crestOf: 'Lo stemma di {club}',
    recordTitle: 'La tua scheda',
    age: 'Età',
    ageValue: '{years} anni',
    ageMissing: 'Non indicata',
    foot: 'Piede',
    footPlaceholder: 'Non dichiarato',
    nationality: 'Nazionalità',
    nationalityPlaceholder: 'Non dichiarata',
    figcNumber: 'Matricola FIGC',
    figcNumberMissing: 'Non indicata',
    editRecord: 'Correggi',
    careerTitle: 'La tua carriera',
    careerLabel: 'Ogni società in cui sei stato tesserato',
    careerCurrent: 'attuale',
    noCareer: 'Nessun tesseramento registrato.',
    editProfile: 'Modifica il tuo profilo',
    previewBanner: 'Stai vedendo il tuo profilo come lo vedono gli altri.',
    previewExit: "Esci dall'anteprima",
  },
  otherPlayerEdit: {
    title: 'Modifica il suo profilo',
    description: 'I suoi dati, e chi li vede.',
    contactTitle: 'I suoi contatti',
    contactDescription: 'Il numero a cui lo raggiunge la sua società.',
    contactReserved:
      'Nome, data di nascita e codice fiscale sono quelli con cui la società lo ha registrato: li corregge lei.',
    visibilityTitle: 'Chi vede il suo profilo',
    visibilityDescription:
      'La sua società vede sempre tutto. Questi decidono cosa legge chiunque altro su Volée.',
    isPublic: 'Mostra il suo profilo agli altri su Volée',
    showsRecord: 'La sua scheda: età, ruolo, piede, nazionalità',
    showsClub: 'La società e la squadra con cui gioca ora',
    showsCareer: 'Le stagioni in cui ha giocato prima',
    closedHint: 'Il suo profilo è chiuso: nessuno fuori dalla sua società può aprirlo.',
    preview: 'Vedi il suo profilo come lo vedono gli altri',
    backToProfile: 'il suo profilo',
    photoTitle: 'La sua foto',
    photoDescription: 'Compare sul suo profilo. Quadrata, e l’inquadratura la scegli tu.',
    cropTitle: 'Inquadra la sua foto',
    showsPhoto: 'La sua foto',
    showsStats: 'Le statistiche delle sue partite',
  },
  myPlayerEdit: {
    backToProfile: 'il tuo profilo',
    title: 'Modifica il tuo profilo',
    description: 'I tuoi dati, e chi li vede.',
    contactTitle: 'I tuoi contatti',
    contactDescription: 'Il numero a cui ti raggiunge la tua società.',
    contactReserved:
      'Nome, data di nascita e codice fiscale sono quelli con cui la società ti ha registrato: li corregge lei.',
    visibilityTitle: 'Chi vede il tuo profilo',
    visibilityDescription:
      'La tua società vede sempre tutto. Questi decidono cosa legge chiunque altro su Volée.',
    isPublic: 'Mostra il mio profilo agli altri su Volée',
    showsRecord: 'La mia scheda: età, ruolo, piede, nazionalità',
    showsClub: 'La società e la squadra con cui gioco ora',
    showsCareer: 'Le stagioni in cui ho giocato prima',
    closedHint: 'Il tuo profilo è chiuso: nessuno fuori dalla tua società può aprirlo.',
    saved: 'Salvato.',
    save: 'Salva',
    preview: 'Vedi il tuo profilo come lo vedono gli altri',
    plan: 'Il tuo piano',
    photoTitle: 'La tua foto',
    photoDescription: 'Compare sul tuo profilo. Quadrata, e l’inquadratura la scegli tu.',
    uploadPhoto: 'Scegli una foto',
    replacePhoto: 'Sostituisci la foto',
    removePhoto: 'Rimuovi',
    cropTitle: 'Inquadra la tua foto',
    cropConfirm: 'Usa questa',
    cropPhone: 'Sul telefono',
    cropWide: 'Sul computer',
    cropCancel: 'Annulla',
    photoTooLarge: 'La foto deve pesare meno di {maxMb} MB.',
    photoUnreadable: 'Quel file non si apre come immagine. Provane un altro.',
    photoSaved: 'Foto salvata.',
    photoRemoved: 'Foto rimossa.',
    showsPhoto: 'La mia foto',
    showsStats: 'Le statistiche delle mie partite',
    statsHint:
      'Le statistiche si vedono solo insieme alla squadra della partita: quelle di quest’anno se è acceso anche «la società e la squadra», quelle passate se sono accese anche le stagioni di prima.',
  },
  followers: {
    title: 'Chi ti segue',
    description:
      'Chi ti segue vede il tuo profilo e i tuoi highlights. Non vede preferiti e playlist, non riceve mail su di te e non decide niente.',
    remove: 'Togli',
    removeTitle: 'Togliere {name}?',
    removeBody:
      'Non vedrà più il tuo profilo. Per ora non potrai farti seguire di nuovo da {name}: arriverà più avanti.',
    removeCancel: 'Annulla',
    removed: '{name} non ti segue più.',
    was: {
      mother: 'Madre · era tua tutrice',
      father: 'Padre · era tuo tutore',
      guardian: 'Tutore legale · era tuo tutore',
    },
  },
  // «Da oggi decidi tu»: the step after the first access from 14 (spec #278, prototype screen 6).
  autonomy: {
    badge: '14 anni',
    title: 'Da oggi decidi tu',
    description: 'Hai compiuto 14 anni: il tuo profilo lo gestisci tu.',
    descriptionOne:
      'Hai compiuto 14 anni: il tuo profilo lo gestisci tu. {names} ora ti segue: vede il profilo, non decide niente, e puoi toglierlo.',
    descriptionMany:
      'Hai compiuto 14 anni: il tuo profilo lo gestisci tu. {names} ora ti seguono: vedono il profilo, non decidono niente, e puoi toglierli.',
    consentTitle: {
      mother: 'Il consenso dato da tua madre',
      father: 'Il consenso dato da tuo padre',
      guardian: 'Il consenso dato dal tuo tutore',
    },
    consentBody:
      'Quando ti sei iscritto lo ha dato {name}. Ora è tuo: per ritirarlo scrivi a privacy@volee-football.com.',
    consentTitleUnknown: 'Il consenso dato per te',
    consentBodyUnknown:
      'Quando ti sei iscritto lo ha dato chi aveva la tua tutela. Ora è tuo: per ritirarlo scrivi a privacy@volee-football.com.',
    enter: 'Entra',
    emailTitle: 'Per entrare ti serve una mail tua',
    emailBody:
      'Finora entravi con «{username}». Da oggi la password è tua, e per recuperarla ti serve una mail: confermata, entri con quella.',
  },
  players: {
    title: 'Giocatori',
    description: 'Area protetta con selezione multipla che sopravvive al cambio route.',
    selected: 'Giocatori selezionati',
    clearSelection: 'Svuota la selezione',
    positionFilter: 'Filtra per posizione',
    allPositions: 'Tutte le posizioni',
  },
  // Le squadre della società. Una squadra non ha nome nel modello: è categoria più
  // anno Under più genere, per questo ogni etichetta è composta e non memorizzata.
  teams: {
    title: 'Squadre',
    filters: 'Filtri',
    genderGroup: 'Genere',
    allGenders: 'Tutte',
    ageGroupGroup: 'Categoria',
    allAgeGroups: 'Tutte',
    addSquad: 'Aggiungi squadra',
    empty: 'Questa società non ha ancora nessuna squadra.',
    noMatch: 'Nessuna squadra corrisponde a questi filtri.',
    clearFilters: 'Azzera',
    resultCount: '{count} squadre',
    resultCountOne: '{count} squadra',
  },
  // R19/R20 · l'elenco delle convocazioni condiviso da /me/coach e /me/official.
  teamSheetList: {
    upcomingTitle: 'LE PROSSIME CONVOCAZIONI',
    upcomingEmpty: 'Nessuna partita in calendario.',
    // Sulla card della prossima partita, quando almeno un convocato ha detto «non ci sono».
    notComing: '{count} non ci sono',
    // Accanto al titolo, la card del carosello su cui si sta: «2 / 5».
    upcomingPosition: '{current} / {total}',
    backlogTitle: 'LE CONVOCAZIONI ARRETRATE',
    backlogReason: 'Senza convocazione, nessun highlight per i giocatori.',
    versus: 'VS',
    versusSpoken: 'contro',
    actionNone: 'Prepara la convocazione',
    actionDraft: 'Riprendi la bozza',
    actionPublished: 'Vedi la convocazione',
    statusDraft: 'Bozza',
    // Le arretrate per squadra: cosa conta il numero, la nota della card e la riga di una partita.
    backlogCount: 'da pubblicare',
    backlogOldest: 'la più vecchia è di {when}',
    backlogMore: 'Mostra le altre {n} squadre',
    backlogMoreOne: 'Mostra l’altra squadra',
    backlogLess: 'Mostra meno',
    backlogVersus: 'vs',
    atHome: 'in casa',
    away: 'in trasferta',
  },
  // Una squadra.
  team: {
    // La testata della pagina: la fascia della società, letta come quella della squadra.
    hero: {
      mister: 'Mister {names}',
      girone: 'Girone {code}',
      // Lo stemma è il link alla società: il nome dice dove porta, non cosa disegna.
      toClub: 'Vai alla società {club}',
      coaches: 'Allenatori',
    },
    cover: {
      title: 'LA COPERTINA DELLA SQUADRA',
      note: 'Una foto orizzontale di tutta la squadra, con i ragazzi al centro: la pagina della squadra la taglia da sé, per il telefono e per il computer, come vedete qui.',
      phone: 'Telefono',
      wide: 'Computer',
      upload: 'Scegli una foto',
      replace: 'Sostituisci',
      remove: 'Rimuovi',
      saved: 'Copertina salvata.',
      removed: 'Copertina rimossa.',
      tooLarge: 'Anche ridotta, la foto supera {maxMb} MB: sceglietene un’altra.',
      unreadable: 'Quel file non si apre come immagine: sceglietene un altro.',
    },
    backToTeams: 'le squadre',
    backToTeam: 'la squadra',
    category: 'categoria e anno Under',
    squadLetter: 'Squadra {letter}',
    headCoachFromAppointment: 'dall’incarico di stagione',
    noHeadCoach: 'nessun allenatore in carica',
    change: 'cambia',
    // Resta vero della categoria, che cambia solo Volée. La panchina è del dirigente.
    changeUnavailable: 'Categoria, anno e genere li cambia un dirigente della società.',
    coaches: 'LA PANCHINA',
    // «Modifica la squadra», spec #366: i posti di squadra e lo staff senza posto.
    seatsTitle: 'POSTI DI SQUADRA',
    staffTitle: 'STAFF DELLA SQUADRA',
    seatFree: 'Posto libero',
    seatInvited: 'Invitato, in attesa',
    seatsFull: 'I posti di squadra sono tutti occupati: togliete qualcuno per liberarne uno.',
    revokeOfferOf: 'Revoca l’invito a {email}',
    giveToStaff: 'Datelo a chi è nello staff della squadra',
    seatRole: 'Sul posto, come',
    giveToClubStaff: 'Datelo a una persona dello staff della società',
    giveToClubStaffToo: 'Oppure a una persona dello staff della società',
    noClubStaff: 'Nessun altro nello staff della società può prendere questo posto.',
    pickPerson: 'Scegliete',
    inviteOntoSeat: 'Invita qualcuno su questo posto',
    letIn: 'Invita a entrare',
    letInOf: 'Invita {name} a entrare',
    staffEmpty: 'Nessuno nello staff della squadra senza posto.',
    staffRole: 'Nello staff, come',
    addToStaff: 'Aggiungi allo staff della squadra',
    noStaffToAdd: 'Nessun altro nello staff della società.',
    removeCoach: 'Togli',
    removeCoachOf: 'Togli {name}',
    removeCoachTitle: 'Togliere {name} dalla squadra {squad}?',
    removeCoachBody:
      'Esce dal posto e dalla squadra: non gestirà più la rosa, il link d’iscrizione e le convocazioni. Il posto resta libero, e la persona resta nello staff della società.',
    removeStaffBody: 'Esce dallo staff della squadra. Resta nello staff della società.',
    seatGiven: 'Posto assegnato.',
    staffAdded: 'Aggiunto allo staff della squadra.',
    staffAddedSeatsTaken:
      'I posti della squadra sono occupati: aggiunto allo staff della squadra, senza posto.',
    seatFreed: 'Tolto dalla squadra: il posto è libero.',
    staffRemoved: 'Tolto dallo staff della squadra.',
    seniores: 'Nessun limite (seniores)',
    bothYears: '1° e 2° anno',
    underAgeOption: 'Under {years}',
    categoryField: 'Categoria',
    categoryOption: '{group} U{years} · {gender}',
    categoryOptionBothYears: '{group} 1° e 2° anno · {gender}',
    categoryOptionSeniores: '{group} · {gender}',
    ageGroup: 'Categoria',
    underAge: 'Limite di età',
    gender: 'Genere',
    save: 'Salva',
    cancel: 'Annulla',
    saved: 'Squadra salvata.',
    requiredField: 'Obbligatorio',
    addTitle: 'Aggiungi una squadra',
    addClose: 'Chiudi',
    addNote:
      'Una società ha una squadra per categoria: Allievi A e B sono la stessa squadra in due gironi.',
    add: 'Aggiungi',
    adding: 'Aggiunta in corso…',
    added: 'Squadra aggiunta.',
    remove: 'Elimina questa squadra',
    removeTitle: 'Eliminare la squadra {squad}?',
    removeWarning:
      'La squadra viene eliminata. Le iscrizioni e gli incarichi, se ce ne sono, la trattengono.',
    removeWarningRoster:
      'Questa squadra ha {players} in rosa: eliminandola escono dalla rosa, e una squadra ricreata è un’altra squadra. I tesseramenti restano alla società.',
    removeYes: 'Elimina',
    removed: 'Squadra eliminata.',
    enrolments: 'LE ISCRIZIONI',
    enrolmentsEmpty: 'Questa squadra non è iscritta a nessun girone in questa stagione.',
    rosterTitle: 'LA ROSA',
    manage: 'Gestisci',
    rosterCount: '{count} {noun}',
    calendar: 'IL CALENDARIO',
    scheduled: 'in programma',
    calendarEmpty: 'Nessuna partita in calendario.',
    notFound: 'Questa squadra non esiste.',
    inviteLink: {
      title: 'Link d’iscrizione',
      explain:
        'Chi apre questo link iscrive il proprio figlio in questa leva. Mandatelo sul gruppo WhatsApp della squadra.',
      durationLabel: 'Quanto dura',
      durations: { 24: '24 ore', 72: '3 giorni', 168: '7 giorni' },
      activate: 'Attiva il link',
      activating: 'Attivo il link…',
      reactivate: 'Riattiva',
      stateActive: 'Attivo',
      stateExpired: 'Scaduto',
      expiresAt: 'Scade il {date} alle {time}',
      // Not «Scaduto il…»: the badge beside this line already says «Scaduto».
      expiredOn: 'il {date} alle {time}',
      loading: 'Carico il link…',
      linkLabel: 'Link d’iscrizione',
      copyLabel: 'Copia',
      copiedMessage: 'Link copiato',
      revealLabel: 'Mostra il link',
      hideLabel: 'Nascondi il link',
      keepPrivate: 'Condividetelo solo con le famiglie di questa leva.',
      rotate: 'Ruota il link',
      rotateTitle: 'Ruotare il link d’iscrizione della squadra {squad}?',
      rotateBody:
        'Il link di adesso smette subito di funzionare: a chi ce l’ha servirà quello nuovo, che parte adesso con la stessa durata. Le richieste d’iscrizione già arrivate restano dove sono.',
      rotateYes: 'Ruota',
      deactivate: 'Disattiva',
      deactivateTitle: 'Disattivare il link d’iscrizione della squadra {squad}?',
      deactivateBody:
        'Chi ha il link non potrà più usarlo, e la squadra resta senza link finché non ne attivate uno nuovo. Le richieste d’iscrizione già arrivate restano dove sono.',
      deactivateYes: 'Disattiva',
      // Il messaggio con cui si apre WhatsApp di chi manda. «tuo figlio» sempre: una frase per ogni leva.
      share: {
        label: 'Invia su WhatsApp',
        copyLabel: 'Copia il messaggio',
        copiedMessage: 'Messaggio copiato',
        withClub:
          'Ecco il link per iscrivere tuo figlio alla squadra {team} di {club} su Volée: {link}',
        withoutClub: 'Ecco il link per iscrivere tuo figlio alla squadra {team} su Volée: {link}',
        validUntil: 'Il link vale fino al {date} alle {time}.',
      },
    },
  },
  // Togliere una squadra. Una pagina e non un dialog: nel design system non c’è.
  teamRemoval: {
    title: 'Questa squadra non esiste più',
    intro:
      'Prima di toglierla, ecco che cosa si porta via. Nel modello i giocatori sono legati alla società e non alla squadra, quindi restano tesserati: si perde il loro legame con questa squadra.',
    carriesOff: 'CHE COSA SI PORTA VIA',
    enrolments: 'le iscrizioni ai gironi',
    enrolmentsDetail: 'la squadra esce dalle classifiche in cui è iscritta',
    coach: 'l’incarico dell’allenatore',
    coachDetail: 'l’allenatore resta nella società, perde questa squadra',
    matches: 'le partite in calendario',
    matchesDetail: 'quelle già giocate e quelle in programma',
    players: 'i giocatori in rosa',
    playersDetail: 'restano tesserati per la società: non si perdono',
    toConfirm:
      'Che cosa accade davvero a una squadra dichiarata inesistente che contiene già giocatori e partite giocate: si nasconde, o si cancella? Le partite già riprese non possono sparire. Probabilmente va disattivata e non eliminata, ma va deciso.',
    confirm: 'Sì, toglila dall’elenco',
    cancel: 'Annulla, torna alla squadra',
  },
  // La prima e la seconda divisa di una società (CONTEXT.md § «Le divise»).
  kits: {
    title: 'Le divise della società',
    description: 'La prima e la seconda divisa, comuni a tutte le vostre squadre.',
    backToClub: 'la società',
    notAuthorised: 'Non autorizzato',
    notAuthorisedBody: 'Le divise di questa società le cambia chi la dirige.',
    notFound: 'Questa società non esiste.',
    teamsTitle: 'Le divise delle squadre',
    teamsEmpty: 'Nessuna squadra ha divise proprie: usano quelle della società.',
    teamsOpen: 'Apri le loro divise',
    design: 'disegno',
    primaryColor: 'colore principale',
    secondaryColor: 'secondo colore',
    shortsColor: 'pantaloncini',
    pickPrimary: 'Scegli il colore principale',
    pickSecondary: 'Scegli il secondo colore',
    pickShorts: 'Scegli il colore dei pantaloncini',
    notChosen: 'ancora da scegliere',
    save: 'Salva',
    remove: 'Togli',
    saved: '{kit} salvata.',
    removed: '{kit} tolta.',
    required: 'Campo obbligatorio.',
    photo: {
      choose: 'Scegli o scatta una foto',
      change: 'Cambia foto',
      note: 'La foto resta sul telefono: si legge qui, non si carica e non si salva.',
      opening: 'Apro la foto…',
      unreadable: 'Questa foto non si apre qui: prova con un JPEG o un PNG.',
      photoLabel: 'La foto della divisa: tocca un colore',
      stepsLabel: 'Il colore che prendi',
      position: '{position} di {total}',
      hint: 'Il tocco legge una piccola area, non un punto: una piega o un’ombra non contano.',
      doneTitle: 'Fatto: i colori sono presi',
      doneHint: 'Per correggerne uno, premi il suo colore qui sotto e tocca di nuovo la foto.',
      redo: 'rifai',
      shirt: 'Maglia',
      second: 'Secondo colore',
      shorts: 'Pantaloncini',
      tapShirt: 'Tocca la maglia',
      tapSecond: 'Tocca il secondo colore della maglia',
      tapShorts: 'Tocca i pantaloncini',
      redoShirt: 'Rifai: tocca la maglia',
      redoSecond: 'Rifai: tocca il secondo colore della maglia',
      redoShorts: 'Rifai: tocca i pantaloncini',
    },
  },
  // Le divise proprie di una squadra, in più di quelle della società (CONTEXT.md § «Le divise»). Il
  // modulo, i colori e le frasi di salvataggio sono di `kits`: qui solo ciò che nomina la squadra.
  teamKits: {
    title: 'Le divise della squadra',
    description:
      'La prima e la seconda divisa della squadra: si aggiungono a quelle della società.',
    notAuthorisedBody:
      'Le divise di questa squadra le cambiano la società e chi ha un posto sulla squadra.',
  },
  // La pagina dove una squadra si corregge, come quella della società.
  teamEdit: {
    title: 'Modifica la squadra',
    dataTitle: 'I DATI DELLA SQUADRA',
    removeTitle: 'ELIMINA LA SQUADRA',
    notAuthorisedBody: 'Questa pagina la aprono la società e chi ha un posto sulla squadra.',
  },
  // La rosa di una squadra.
  roster: {
    title: 'Gestisci la rosa',
    searchLabel: 'cerca per nome',
    positionGroup: 'Ruolo',
    allPositions: 'tutti',
    noPosition: 'ruolo non registrato',
    overAge: 'fuoriquota',
    roleOf: 'Ruolo di {name}',
    roleNote: 'Il ruolo vale per il profilo del giocatore, non solo per questa squadra.',
    roleChanged: '{name} ora gioca come {role}',
    added: '{name} è in rosa',
    addedMany: '{count} giocatori in rosa',
    remove: 'togli',
    removeOf: 'Togli {name}',
    removeTitle: 'Togliere {name} dalla rosa di {squad}?',
    removeBody:
      'Non sarà più convocabile con questa squadra. Resta tesserato della società, senza squadra.',
    removeYes: 'Togli',
    removed: '{name} non è più in rosa',
    // «Senza squadra»: i tesserati attivi che non stanno in nessuna rosa (CONTEXT.md).
    unassignedTitle: 'SENZA SQUADRA',
    unassignedSearchLabel: 'cerca fra i senza squadra',
    unassignedPositionGroup: 'Filtra i senza squadra per ruolo',
    unassignedListLabel: 'I tesserati senza squadra',
    unassignedEmpty: 'Non c’è nessun tesserato senza squadra.',
    addUnassigned: 'Aggiungi',
    addUnassignedCount: 'Aggiungi {count}',
    addUnassignedCancel: 'Annulla',
    // Chi corrisponde e sta già altrove: dirlo, o sembrerebbe non tesserato.
    alreadyElsewhere: '{name} è già in {team}',
    seeAllTeams: 'Vedi tutte le squadre',
    emptyTitle: 'Nessun giocatore in questa rosa',
    emptyBody:
      'Volée carica le anagrafiche durante l’attivazione. Se questa rosa è vuota, o la squadra è nuova, o i dati non ci sono arrivati.',
    noMatch: 'Nessun giocatore corrisponde a questi filtri.',
  },
  // La partita. Una pagina sola per tutti: la versione pubblica è questa filtrata —
  // chi guarda da fuori vede meno dati, non un’altra schermata.
  match: {
    competition: '{competition} · girone {group}',
    whenAndWhere: '{date} · {time} · {pitch}',
    timeAndPitch: 'ore {time} · {pitch}',
    statusFinal: 'Finale',
    goalTimeline: 'I gol della partita',
    notPlayedYet: 'non ancora giocata',
    sideCategory: '{ageGroup} U{underAge}',
    sideCategoryBothYears: '{ageGroup} 1° e 2° anno',
    watch: 'Guarda la partita',
    recordedMatch: 'la partita ripresa · {minutes} min',
    recordingTitle: 'La partita',
    recordingLength: '{minutes} minuti · ripresa integrale',
    unlock: 'Sblocca la partita',
    highlightMinute: '{minute}’',
    lockedClip: 'Sblocca per guardare',
    tabHighlights: 'highlight',
    tabScoreLines: 'tabellino',
    tabMeasures: 'statistiche',
    highlightsTitle: 'GLI HIGHLIGHT',
    highlightCount: '{count}',
    highlightSummary: '{minute}’ · {action} · {player}',
    seeAllHighlights: 'Vedi tutti gli highlight',
    noHighlights: 'Nessun highlight per questa partita.',
    scoreLinesTitle: 'IL TABELLINO',
    scoreLineSummary: '{minute}’ · {action} · {player}',
    noScoreLines: 'Il tabellino è vuoto.',
    seeLineup: 'Vedi i convocati',
    onPitchTitle: 'I GIOCATORI IN CAMPO',
    seeAllPlayers: 'Vedi tutti i giocatori',
    squadRosterTitle: '{club} · LA CONVOCAZIONE',
    editLineup: 'MODIFICA',
    // La convocazione come la leggono le famiglie: la risposta per ciascuno dei propri, poi la squadra.
    callUp: {
      calledTitle: '{name} è convocato',
      number: 'N. {number}',
      meetingAtPitch: 'Ritrovo alle {time} al campo',
      meetingAtPlace: 'Ritrovo alle {time}, {place}',
      notCalledTitle: '{name} non è nella convocazione di questa partita',
      notCalledCoach: 'Per qualunque domanda c’è l’allenatore, {coach}.',
      yourChild: 'Tuo figlio',
      you: 'Tu',
      shirt: 'Maglia numero {number}',
      status: 'Convocato',
      notCalledEyebrow: 'La convocazione',
      meetingLabel: 'Ritrovo',
      meetingPitch: 'Al campo',
      rosterLabel: 'Convocati',
      answerLabel: 'Risposta di {name}',
      answerComing: 'Ci sono',
      answerNotComing: 'Non ci sono',
      notComingTitle: '{count} non ci sono',
      answersLine: '{coming} ci sono · {notComing} non ci sono · {open} senza risposta',
      markComing: 'Ci sono',
      markNotComing: 'Non ci sono',
      markOpen: 'Senza risposta',
      answeredBy: 'da {name}',
      // Lo stato della convocazione, nella pillola della sua scheda sulla pagina partita.
      summaryToCall: 'Da convocare',
      summaryDraft: 'Bozza',
      summaryPublished: 'Pubblicata',
      summaryBacklog: 'Arretrata',
      summaryPlayed: 'Parte per l’analisi',
      summarySent: 'Partita per l’analisi',
      calledCount: 'convocati',
      calledCountOne: 'convocato',
      hintToCall: 'Scegli chi viene, la divisa e il ritrovo: poi la pubblichi alle famiglie.',
      hintBacklog:
        'Scegli chi era convocato, con i numeri: senza convocazione, nessun highlight per i giocatori.',
      hintDraft: 'Bozza salvata {when}. Le famiglie non la vedono.',
      hintDraftUnsaved: 'Le famiglie non la vedono finché non la pubblichi.',
      savedWhen: '{day} alle {time}',
      callUpSquad: 'Convoca la squadra',
      resumeDraft: 'Riprendi la bozza',
      notesLabel: 'Note',
      answersLabel: 'Risposte',
      // Dove staranno i convocati, finché non ce n'è uno da mostrare.
      rosterEmpty: 'Qui compariranno i convocati.',
      draftChosen: '{count} giocatori scelti, non ancora pubblicati.',
      draftChosenOne: '{count} giocatore scelto, non ancora pubblicato.',
      // La fascia su cui atterra il flusso, dopo «Pubblica» o «Aggiorna».
      landedPublishedText:
        '{count} convocati: le famiglie la vedono già qui sotto. Manca solo il messaggio sul gruppo.',
      landedPublishedTextOne:
        '{count} convocato: le famiglie la vedono già qui sotto. Manca solo il messaggio sul gruppo.',
      landedUpdatedText:
        'Le famiglie vedono già le modifiche qui sotto. Se serve, avvisale di nuovo.',
    },
    inChampionship: 'LA PARTITA NEL CAMPIONATO',
    matchday: 'giornata {matchday}',
    seeStandings: 'Vedi la classifica del girone',
    processingTitle: 'Ripresa in elaborazione',
    processingBody:
      'La partita è finita e il sistema sta ancora lavorando il video. Highlight e misure compaiono quando ha finito.',
    unavailableTitle: 'Ripresa non disponibile',
    unavailableBody:
      'Nessun video per questa partita: la telecamera era guasta o assente, oppure si è giocato altrove.',
    trackingFailedTitle: 'Giocatori non riconosciuti',
    trackingFailedBody:
      'Il video c’è ma il sistema non ha riconosciuto i giocatori, quindi non ci sono misure individuali né highlight automatici. Il risultato e il tabellino restano.',
    notFound: 'Questa partita non esiste.',
  },
  // Un highlight, e la condivisione che il consenso non ha ancora deciso.
  highlight: {
    backToMatch: 'la partita',
    clip: 'l’azione ritagliata · {seconds} s',
    context: '{minute}’ · {side} · {origin}',
    inThisAction: 'CHI È IN QUESTA AZIONE',
    playerNote: 'Il giocatore dell’azione apre il suo profilo — area 50 · Profilo giocatore.',
    shareTitle: 'CONDIVIDI QUESTO HIGHLIGHT',
    copyLink: 'copia il link',
    download: 'scarica',
    share: 'condividi',
    shareBlocked:
      'Quanto si può condividere dipende dal consenso alla pubblicazione video e dal livello di visibilità: entrambi sono decisioni aperte. Se e come si condivide l’highlight di un minore fuori dalla piattaforma non è deciso.',
    minorBlocked:
      'Chi può guardare e condividere l’highlight di un minore dipende dal consenso per la pubblicazione video, che nel modello è per stagione e per società. Da decidere con il consulente privacy.',
    otherHighlights: 'GLI ALTRI HIGHLIGHT DELLA PARTITA',
    noOtherHighlights: 'Nessun altro highlight per questa partita.',
    unavailableTitle: 'Il video non si può vedere',
    unavailableBody:
      'O il consenso alla pubblicazione video è stato revocato, oppure il file non c’è.',
    whatItWas: 'DI CHE AZIONE SI TRATTAVA',
    unavailableBlocked:
      'Il fatto che l’azione esista resta visibile anche senza il video? E se la causa è un consenso revocato, che cosa si dice al ragazzo: distinguere un guasto da una revoca è una scelta che tocca la privacy, non solo il messaggio.',
    notFound: 'Questo highlight non esiste.',
  },
  // La classifica del girone. Ogni girone ha la sua: non si sommano mai.
  standings: {
    title: 'La classifica del girone',
    columnPosition: '#',
    columnClub: 'SQUADRA',
    columnPlayed: 'G',
    columnWon: 'V',
    columnDrawn: 'N',
    columnLost: 'P',
    columnGoalsFor: 'GF',
    columnGoalsAgainst: 'GS',
    columnGoalDifference: 'DR',
    columnPoints: 'PT',
    note:
      'Ordinata per punti, differenza reti, reti fatte e nome della società. Non è la ' +
      'classifica avulsa FIGC e non indica promozioni o retrocessioni.',
  },
  // I campionati che una società gioca. L'unità è il girone: iscritte, calendario
  // e classifica appartengono a uno solo, e non si sommano mai fra due.
  matches: {
    title: 'Partite',
    empty: 'Nessuna partita in calendario.',
    emptyFiltered: 'Nessuna partita con questi filtri.',
    scopeAll: 'Tutte',
    scopeUpcoming: 'Prossime',
    scopePlayed: 'Giocate',
    filters: 'Filtri',
    clearFilters: 'Azzera',
    team: 'Squadra',
    anyTeam: 'Tutte le squadre',
    group: 'Girone',
    anyGroup: 'Tutti i gironi',
    venue: 'Dove',
    venueAnywhere: 'Ovunque',
    venueHome: 'Casa',
    venueAway: 'Trasferta',
    from: 'Dal',
    to: 'Al',
    withPostponed: 'Mostra anche le rinviate',
    resultCount: '{count} partite',
    resultCountOne: '{count} partita',
    postponed: 'Rinviata',
    postponedFilter: 'Con le rinviate',
    periodFrom: 'Dal {date}',
    periodTo: 'Fino al {date}',
    periodBetween: 'Dal {from} al {to}',
    versus: 'VS',
    versusSpoken: 'contro',
    seeMatch: 'Vedi la partita',
    scoreSpoken: '{home} a {away}',
    // Il filtro che lascia le partite senza una convocazione pubblicata; la sua chip dice le stesse parole.
    toPrepareFilter: 'Da convocare',
  },
  leagues: {
    title: 'I vostri campionati',
    listTitle: 'I GIRONI DELLA STAGIONE',
    groupCode: 'girone {code}',
    withdrawn: 'ritirata',
    ourClub: 'la vostra società',
    empty: 'Nessuna squadra della società è iscritta a un girone in questa stagione.',
    seasonTitle: 'I campionati',
    seasonEmpty: 'Nessun girone è ancora stato aperto per questa stagione.',
    enrolledCount: '{count} iscritte',
    backToLeagues: 'i campionati',
    notFound: 'Questo girone non esiste.',
    entriesSection: 'iscritte',
    calendarSection: 'calendario',
    standingsSection: 'classifica',
    entriesTitle: 'LE SQUADRE ISCRITTE',
    entriesEmpty: 'Nessuna squadra è ancora iscritta a questo girone.',
    calendarTitle: 'IL CALENDARIO',
    calendarEmpty: 'Nessuna partita nel calendario di questo girone.',
    standingsEmpty: 'Nessuna squadra di questo girone ha ancora una riga in classifica.',
    standingsTitle: 'LA CLASSIFICA',
    notPlayedYet: 'Nessuna giornata giocata: l’ordine è quello alfabetico.',
  },
  // La convocazione, in tre passi: chi viene, la divisa, il riepilogo.
  lineup: {
    backToMatch: 'la partita',
    empty: 'Nessun tesserato di questa società è ancora convocabile.',
    notFound: 'Non trovi la tua squadra per questa partita.',
    back: 'Indietro',
    stepsLabel: 'Tappe della convocazione',
    stepRoster: 'Rosa',
    barLabel: 'Comandi della convocazione',
    next: 'Continua',
    rosterTitle: 'SCEGLI I GIOCATORI',
    resumeLast: 'Riprendi l’ultima convocazione',
    searchLabel: 'Cerca un nome',
    calledUpCount: '{count} / 20 convocati',
    noNumberNote: 'Chi non ha numero non avrà statistiche né highlights.',
    squadSectionTitle: 'LA ROSA',
    otherSquadsTitle: 'DA ALTRE LEVE',
    calledUpLimitReached: 'Ci sono già 20 convocati: togline uno per aggiungere questo.',
    // Il campo accanto a un convocato: il nome si legge e non si scrive, «N.» è la sola parola a schermo.
    shirtNumberField: 'Numero di maglia di {name}',
    shirtNumberPlaceholder: 'N.',
    shirtNumberTaken: 'Numero già usato',
    // Nella barra, sopra «Continua» e «Pubblica»: il motivo per cui la via è chiusa.
    sharedNumberNote: 'Due convocati hanno lo stesso numero di maglia',
    meetingTimeMissingNote: 'Manca l’ora del ritrovo',
    // Il pannello dei convocati: accanto alla rosa su uno schermo largo, e nel riepilogo.
    boardTitle: 'I convocati',
    boardEmptyRoster: 'Tocca un giocatore a sinistra per convocarlo: qui gli scrivi il numero.',
    boardEmptySummary: 'Nessuno è convocato: torna alla rosa.',
    boardRemove: 'Togli {name}',
    // Il foglio che convoca un tesserato di un'altra leva della società.
    otherSquads: {
      open: 'Convoca da un’altra leva',
      title: 'Convoca da un’altra leva',
      search: 'Cerca per nome',
      filterLabel: 'Leva',
      all: 'Tutte',
      noSquad: 'Senza leva',
      empty: 'Nessuno con questo nome nelle altre leve.',
      close: 'Chiudi',
      done: 'Fatto',
    },
    stepKit: 'Divisa',
    stepSummary: 'Riepilogo',
    kitTitle: 'LA DIVISA',
    kitQuestion:
      'Con che divisa scende in campo {club}? Potete indicarla anche più tardi, o dopo la partita.',
    kitChoices: 'La divisa di gara',
    kitProposed: 'Proposta',
    kitOtherDetail: 'Pettorine o una terza maglia: solo per questa partita',
    kitOtherFromFirst:
      'Già compilato con la prima divisa: cambiate solo ciò che serve, per esempio la maglia delle pettorine.',
    kitOtherFromProposed:
      'Già compilato con la divisa proposta ({kit}): cambiate solo ciò che serve, per esempio la maglia delle pettorine.',
    kitNoKits:
      'Né la squadra né la società hanno ancora le loro divise: per questa partita potete indicare altri colori.',
    kitSetUpClubKits: 'Imposta le divise della società',
    kitSetUpTeamKits: 'Imposta le divise della squadra',
    kitConfirm: 'Conferma: {kit}',
    kitChoose: 'Scegli una divisa',
    kitLater: 'La indico più tardi',
    kitKeep: 'Lascia com’è',
    kitRemove: 'Togli la divisa indicata',
    kitNotGiven: 'non indicata',
    summaryKit: 'Divisa',
    summaryCalledUp: '{count} convocati',
    summaryTitle: 'PRONTA PER LA SQUADRA',
    // Il riepilogo a partita giocata: ritrovo e note si leggono e non si scrivono più.
    summaryTitlePlayed: 'PRONTA PER L’ANALISI',
    playedTitle: 'La partita è giocata: questa convocazione parte per l’analisi.',
    playedNote: 'Ritrovo e note non si scrivono più.',
    summaryReview: 'Rivedi rosa',
    edit: 'Modifica',
    editWhat: 'Modifica {what}',
    changedNotice: 'Hai modifiche non salvate: le famiglie le vedranno appena salvi.',
    // Uscendo da una convocazione pubblicata con modifiche che il server non ha.
    leaveTitle: 'Esci senza aggiornare?',
    leaveBody: 'Le famiglie non vedono le modifiche finché non premi Aggiorna.',
    leaveConfirm: 'Esci',
    leaveStay: 'Resta',
    summaryMissingFigc: '{count} convocati sono senza matricola FIGC.',
    publish: 'Pubblica la convocazione',
    publishedBadge: 'Pubblicata',
    draftBadge: 'Bozza',
    update: 'Aggiorna convocazione',
    confirmedPublished: 'Convocazione pubblicata',
    confirmedUpdated: 'Convocazione aggiornata',
    notifyAgain: 'Avvisa di nuovo',
    numbersTitle: 'I NUMERI DI MAGLIA',
    numbersNote:
      'La partita è cominciata: i convocati non cambiano più, i numeri sì finché la convocazione non parte per l’analisi.',
    numbersSave: 'Salva i numeri',
    numbersSaved: 'Numeri salvati',
    numbersClosed: 'La convocazione è già partita per l’analisi: i numeri sono definitivi.',
    meetingTitle: 'RITROVO E NOTE',
    meetingTime: 'Ora del ritrovo',
    meetingPlace: 'Luogo del ritrovo',
    meetingPlacePlaceholder: 'Al campo',
    meetingTimeRequired: 'Serve anche l’ora',
    notes: 'Note per le famiglie',
    notesCount: '{count} / {max}',
    notify: {
      title: 'Avvisa la squadra',
      published: 'La convocazione è pubblicata.',
      preview: 'Il messaggio',
      whatsapp: 'Manda su WhatsApp',
      copy: 'Copia il messaggio',
      copied: 'Messaggio copiato',
      close: 'Chiudi',
      // Il messaggio con cui si apre WhatsApp di chi manda: i nomi e il nome della divisa, mai i suoi colori.
      message: {
        headline: 'Convocazione {team}: {home} – {away}',
        when: '{day}, calcio d’inizio {time}, {pitch}',
        kit: 'Divisa: {kit}',
        kitFirst: 'prima divisa',
        kitSecond: 'seconda divisa',
        kitOther: 'altri colori, nel link',
        calledUp: '{name} ({number})',
        link: 'Chi è convocato risponde qui: {link}',
      },
    },
  },
  // Ciò che dice un'analisi video importata, sulla partita e sul profilo di un giocatore.
  matchStats: {
    title: 'LE STATISTICHE DELLA PARTITA',
    notYet: 'Le statistiche arrivano quando l’analisi video della partita è conclusa.',
    source: 'Dall’analisi video della partita.',
    teamsLabel: 'Le statistiche delle due squadre',
    playersTitle: '{club} · STATISTICHE DEI GIOCATORI',
    playersLabel: 'Le statistiche dei giocatori di {club}',
    columnShirt: 'N.',
    columnPlayer: 'Giocatore',
    playersHidden: 'Le statistiche dei giocatori le vede chi ha un posto nella loro società.',
    profileTitle: 'STATISTICHE DELLE PARTITE',
    profileLabel: 'Le statistiche partita per partita',
    columnMatch: 'Partita',
    matchCell: '{day} · vs {club}',
    noneYet: 'Nessuna partita analizzata finora.',
    units: { percent: '{value}%', metres: '{value} m' },
    format: 'Formato partita: {players} contro {players}',
    sevenASide: 'Partita a 7: UbiTrack misura meno statistiche.',
    involvementNotComparable:
      'Nelle partite a 7 il coinvolgimento nelle azioni si calcola su meno statistiche: non è confrontabile con le partite a 9 e a 11.',
    areas: {
      shooting: 'Tiro',
      creation: 'Creazione',
      passing: 'Passaggi',
      defending: 'Difesa',
      setPieces: 'Palle inattive',
      discipline: 'Disciplina',
      goalkeeping: 'Portiere',
      player: 'Giocatore',
    },
    teamPlayerArea: 'Altro',
    metrics: {
      shots_total: 'Tiri totali',
      shots_on_target: 'Tiri in porta',
      shots_off_target: 'Tiri fuori',
      shots_blocked: 'Tiri respinti',
      shot_accuracy_pct: 'Precisione al tiro',
      goals: 'Gol',
      assists: 'Assist',
      key_passes: 'Passaggi chiave',
      dribbles_successful: 'Dribbling riusciti',
      dribbles_failed: 'Dribbling falliti',
      crosses_attempted: 'Cross',
      crosses_completed: 'Cross riusciti',
      cross_accuracy_pct: 'Precisione nei cross',
      passes: 'Passaggi totali',
      passes_completed: 'Passaggi riusciti',
      pass_accuracy_pct: 'Precisione nei passaggi',
      possession_pct: 'Possesso palla',
      tackles_attempted: 'Contrasti',
      tackles_won: 'Contrasti vinti',
      tackle_success_pct: 'Successo nei contrasti',
      interceptions: 'Intercetti',
      duels_total: 'Duelli',
      duels_won: 'Duelli vinti',
      duels_won_pct: 'Duelli vinti, quota',
      aerial_duels_total: 'Duelli aerei',
      aerial_duels_won: 'Duelli aerei vinti',
      aerial_duels_won_pct: 'Duelli aerei vinti, quota',
      ground_duels_total: 'Duelli a terra',
      ground_duels_won: 'Duelli a terra vinti',
      ground_duels_won_pct: 'Duelli a terra vinti, quota',
      ball_recoveries: 'Palloni recuperati',
      interventions: 'Interventi',
      ball_losses_under_pressure: 'Palle perse sotto pressione',
      clearances: 'Spazzate',
      blocks: 'Respinte',
      corners: 'Calci d’angolo',
      throw_ins: 'Rimesse laterali',
      free_kicks: 'Punizioni',
      set_pieces: 'Calci piazzati',
      fouls_committed: 'Falli commessi',
      fouls_suffered: 'Falli subiti',
      yellow_cards: 'Cartellini gialli',
      red_cards: 'Cartellini rossi',
      offsides: 'Fuorigioco',
      saves: 'Parate',
      goals_conceded: 'Gol subiti',
      save_pct: 'Percentuale di parate',
      claims_exits_total: 'Uscite',
      claims_exits_successful: 'Uscite riuscite',
      claims_exits_success_pct: 'Uscite, riuscita',
      goal_kicks_total: 'Rinvii',
      goal_kicks_successful: 'Rinvii riusciti',
      goal_kick_accuracy_pct: 'Precisione dei rinvii',
      buildup_involvement_pct: 'Coinvolgimento nella costruzione',
      minutes_played: 'Minuti giocati',
      distance_covered_m: 'Distanza percorsa',
      involvement_pct: 'Coinvolgimento nelle azioni',
      mistakes: 'Errori',
    },
  },
  highlights: {
    title: 'Highlights',
    showcase: 'In evidenza',
    player: 'Gli highlights in evidenza',
    previous: 'Clip precedente',
    next: 'Clip successiva',
    play: 'Riproduci',
    pause: 'Pausa',
    rail: 'Le clip in evidenza',
    latestMatches: 'Le ultime partite',
    clipEyebrow: "{kind} · {minute}'",
    actions: '{count} azioni',
    actionsOne: '{count} azione',
    matchSummary: '{actions} · {length}',
    toTheSeason: 'Tutti gli highlights · {matches}',
    matchCount: '{count} partite',
    matchCountOne: '{count} partita',
    backToSeason: 'tutti gli highlights',
    backToYourProfile: 'il tuo profilo',
    backToTheirProfile: 'il suo profilo',
    matches: 'Partite',
    nothingToShow: 'Nessun highlight da mostrare.',
    clipMinute: "{minute}'",
    matchPlayer: 'Gli highlights della partita',
    previousAction: 'Azione precedente',
    nextAction: 'Azione successiva',
    playAll: 'Riproduci tutto',
    position: '{position} di {total}',
    actionList: 'Le azioni',
    kindFilter: 'Filtra le azioni',
    allKinds: 'Tutte',
    playbackFailed: 'Non riusciamo a riprodurre gli highlights.',
    choose: 'Scegli',
    chooseTitle: 'Scegli cosa mettere in evidenza',
    chooseDescription: 'Fino a {places} clip, nell’ordine in cui le tocchi.',
    choosable: 'Le clip da mettere in evidenza',
    save: 'Salva',
    cancel: 'Annulla',
    close: 'Chiudi',
    favourite: 'Preferita',
    more: 'Altro su questa clip',
    feature: 'Metti in evidenza',
    unfeature: 'Togli dall’evidenza',
    showcaseFull: 'In evidenza ce ne stanno al massimo {places}.',
    addToPlaylist: 'Aggiungi a una playlist',
    playlists: 'Le playlist',
    newPlaylist: 'Nuova playlist',
    createPlaylist: 'Crea',
    yourCollections: 'Le tue raccolte',
    favourites: 'Preferiti',
    clipCount: '{count} clip',
    clipCountOne: '{count} clip',
    collectionSummary: '{clips} · {length}',
    emptyCollection: 'Ancora nessuna clip qui.',
    freeClips: 'Le clip gratis',
    locked: 'Bloccata',
    upgrade: 'Fai upgrade del piano',
    inThePlan: 'Inclusa nel piano',
  },
  subscriptions: {
    title: 'Piano',
    description: 'Il tuo piano, se giochi, e quello dei figli di cui sei tutore.',
    priceLine: '{price}/mese per giocatore',
    empty: 'Nessun giocatore da mostrare.',
    uncovered: 'Nessun piano attivo',
    subscribe: 'Attiva il piano',
    cancel: 'Disdici',
    cancelConfirmTitle: 'Disdire il piano di {name}?',
    cancelConfirmBody: 'Resta attivo fino alla fine del periodo già pagato, poi non si rinnova.',
    cancelConfirm: 'Disdici il piano',
    cancelKeep: 'Indietro',
    cancelDone: 'Piano disdetto.',
    changeCard: 'Cambia carta',
    changeCardTitle: 'Cambia la carta di pagamento',
    changeCardDescription: 'I prossimi rinnovi saranno addebitati su questa carta.',
    changeCardSubmit: 'Salva la carta',
    changeCardPending: 'Salvataggio…',
    changeCardLoading: 'Caricamento del modulo di pagamento…',
    changeCardClose: 'Chiudi',
    renewsOn: 'Rinnovo il {date}',
    activeNoDate: 'Attivo',
    cancelledUntil: 'Disdetto, attivo fino al {date}',
    pastDue: 'Pagamento non riuscito: stiamo riprovando',
    activating: 'Attivazione in corso…',
    activatingSlow: 'Il pagamento è stato ricevuto: il piano comparirà a breve.',
    askRow: 'Lo attiva un tuo genitore o tutore',
    askTitle: 'Chiedi al tuo tutore',
    askBody:
      'Sotto i 14 anni il piano lo attiva un tuo genitore o tutore. Manda il link: chi lo apre, con il proprio account, lo attiva per te.',
    askShare: 'Condividi',
    askWhatsApp: 'Invia su WhatsApp',
    askCopy: 'Copia link',
    askCopied: 'Link copiato',
    askMessage: 'Ciao! Mi attivi il piano di Volée? Lo trovi qui: {link}',
    notPayer: 'Pagato da un altro account',
    checkoutTitle: 'Attiva il piano',
    checkoutContinue: 'Continua al pagamento',
    checkoutPending: 'Pagamento in corso…',
    checkoutLoading: 'Caricamento del modulo di pagamento…',
    checkoutNotFound: 'Questo giocatore non è fra quelli per cui puoi attivare un piano.',
    paymentsUnavailable: 'I pagamenti non sono disponibili in questo ambiente.',
    paymentFailed: 'Il pagamento non è andato a buon fine. Riprova.',
    backToList: 'Torna al piano',
    backToPlan: 'il piano',
  },
  // Un comando che il wireframe disegna e che nessun endpoint accetta ancora.
  plannedAction: {
    reason: 'Non ancora disponibile: nessun endpoint accetta questa modifica.',
  },
  forbidden: {
    title: 'Accesso negato',
    description: 'Il tuo profilo non ha i permessi per questa sezione.',
    backToHome: 'Torna all’inizio',
    signOut: 'Esci',
  },
  notFound: {
    title: 'Pagina non trovata',
    description: 'L’indirizzo che hai aperto non esiste.',
    backToHome: 'Torna all’inizio',
  },
  // L’«Annulla» di ogni finestra che chiede prima di un atto che toglie (`ConfirmAct`): una parola sola.
  confirm: {
    cancel: 'Annulla',
  },
  loading: {
    pending: 'Caricamento…',
  },
  pagination: {
    position: 'Pagina {page} di {pageCount}',
    previous: 'Precedente',
    next: 'Successivo',
  },
  filters: {
    remove: 'Togli il filtro {filter}',
    active: '{count} filtri attivi',
    activeOne: '{count} filtro attivo',
  },
  error: {
    title: 'Qualcosa non ha funzionato',
    retry: 'Riprova',
    backToHome: 'Torna all’inizio',
  },
}
